
export default [
  [
    {
      "rus": "Эта женщина иногда смотрит телевизор",
      "eng": "This woman sometimes watches TV"
    },
    {
      "rus": "Эти женщины иногда смотрят телевизор",
      "eng": "These women sometimes watch TV"
    },
    {
      "rus": "Её ребёнок всегда слушает её",
      "eng": "Her child always listens to her",
      "regEng": "/Her (?:child|kid) always listens to her/gm"
    },
    {
      "rus": "Её дети всегда слушают её",
      "eng": "Her children always listen to her",
      "regEng": "/Her (?:children|kids) always listen to her/gm"
    },
    {
      "rus": "Тот мужчина никогда не играет в видео игры",
      "eng": "That man never plays video games"
    },
    {
      "rus": "Те мужчины никогда не играют в видео игры",
      "eng": "Those men never play video games"
    },
    {
      "rus": "Наш ребёнок никогда не ест гамбургеры",
      "eng": "Our child never eats hamburgers"
    },
    {
      "rus": "Наши дети никогда не едят гамбургеры",
      "eng": "Our children never eat hamburgers"
    },
    {
      "rus": "Этот человек часто читает газеты и журналы",
      "eng": "This person often reads newspapers and magazines"
    },
    {
      "rus": "Эти люди часто читают газеты и журналы",
      "eng": "These people often read newspapers and magazines"
    },
    {
      "rus": "Тот мужчина обычно покупает дорогие костюмы",
      "eng": "That man usually buys expensive suits"
    },
    {
      "rus": "Те мужчины обычно покупают дорогие костюмы",
      "eng": "Those men usually buy expensive suits"
    }
  ],
  [
    {
      "rus": "Этот человек редко играет в футбол",
      "eng": "This person rarely plays football",
      "regEng": "/This person (?:rarely|seldom) plays football/gm"
    },
    {
      "rus": "Эти люди редко играют в футбол",
      "eng": "These people rarely play football",
      "regEng": "/These people (?:rarely|seldom) play football/gm"
    },
    {
      "rus": "Эта женщина никогда не носит таких коротких юбок",
      "eng": "This woman never wears such short skirts"
    },
    {
      "rus": "Эти женщины никогда не носят таких коротких юбок",
      "eng": "These women never wear such short skirts"
    },
    {
      "rus": "Этот мужчина обычно слушает ту женщину",
      "eng": "This man usually listens to that woman"
    },
    {
      "rus": "Эти мужчины обычно слушают тех женщин",
      "eng": "These men usually listen to those women"
    },
    {
      "rus": "Эта женщина никогда не смотрит такие шоу",
      "eng": "This woman never watches such shows"
    },
    {
      "rus": "Эти женщины никогда не смотрят такие шоу",
      "eng": "These women never watch such shows"
    },
    {
      "rus": "Этот мужчина всегда носит такие брюки",
      "eng": "This man always wears such trousers"
    },
    {
      "rus": "Эти мужчины всегда носят такие брюки",
      "eng": "These men always wear such trousers"
    },
    {
      "rus": "Ваш ребёнок часто слушает эту песню",
      "eng": "Your child often listens to this song",
      "regEng": "/Your (?:child|kid) often listens to this song/gm"
    },
    {
      "rus": "Ваши дети часто слушают эти песни",
      "eng": "Your children often listen to these songs",
      "regEng": "/Your (?:children|kids) often listen to these songs/gm"
    }
  ],
  [
    {
      "rus": "Они хотят купить хорошую машину",
      "eng": "They want to buy a good car"
    },
    {
      "rus": "Чтобы закончить свою работу, ему нужно спешить",
      "eng": "To finish his work he needs to hurry",
      "regEng": "/(?:To finish his work he needs to (?:hurry(?: up)?|rush))|(?:He needs to (?:hurry(?: up)?|rush) to finish his work)/gm"
    },
    {
      "rus": "Ему нравится посещать интересные места каждый год",
      "eng": "He likes to visit interesting places every year"
    },
    {
      "rus": "Нам нужно найти новую квартиру",
      "eng": "We need to find a new flat",
      "regEng": "/We need to find a new (?:flat|apartment)/gm"
    },
    {
      "rus": "Мне нравится приходить сюда каждую неделю",
      "eng": "I like to come here every week"
    },
    {
      "rus": "Чтобы сделать это, тебе нужно быть сильным",
      "eng": "To do this you need to be strong",
      "regEng": "/(?:To do (?:this|it|that) you need to be strong)|(?:You need to be strong to do (?:this|it|that))/gm"
    }
  ],
  [
    {
      "rus": "Чтобы быть здоровым, тебе нужно есть хорошую еду",
      "eng": "To be healthy you need to eat good food",
      "regEng": "/(?:To be healthy you need to eat good food)|(?:You need to eat good food to be healthy)/gm"
    },
    {
      "rus": "Мне нравится мыть свои ботинки каждый день",
      "eng": "I like to wash my shoes every day",
      "regEng": "/(?:I like to wash my (?:shoes|boots) every day)|(?:I like washing my (?:shoes|boots) every day)/gm"
    },
    {
      "rus": "Она хочет иметь отличную работу",
      "eng": "She wants to have an excellent job"
    },
    {
      "rus": "Я хочу пить зелёный чай каждый день",
      "eng": "I want to drink green tea every day"
    },
    {
      "rus": "Нам нравится помогать своим друзьям всё время",
      "eng": "We like to help our friends all the time"
    },
    {
      "rus": "Чтобы быть сильным и здоровым, ему нужно тренироваться",
      "eng": "To be strong and healthy he needs to exercise",
      "regEng": "/(?:To be strong and healthy he needs to exercise)|(?:He needs to exercise to be strong and healthy)/gm"
    }
  ],
  [
    {
      "rus": "Этот человек часто приезжает сюда",
      "eng": "This person often comes here"
    },
    {
      "rus": "Эти люди часто приезжают сюда",
      "eng": "These people often come here"
    },
    {
      "rus": "Тот ребёнок никогда не пьёт зелёный чай",
      "eng": "That child never drinks green tea",
      "regEng": "/(?:That (?:child|kid) never drinks green tea)/gm"
    },
    {
      "rus": "Те дети никогда не пьют зелёный чай",
      "eng": "Those children never drink green tea",
      "regEng": "/(?:Those (?:children|kids) never drink green tea)/gm"
    },
    {
      "rus": "Эта женщина всегда носит такие длинные платья",
      "eng": "This woman always wears such long dresses"
    },
    {
      "rus": "Эти женщины всегда носят такие длинные платья",
      "eng": "These women always wear such long dresses"
    }
  ],
  [
    {
      "rus": "Этот мужчина иногда работает здесь",
      "eng": "This man sometimes works here"
    },
    {
      "rus": "Эти мужчины иногда работают здесь",
      "eng": "These men sometimes work here"
    },
    {
      "rus": "Ваш ребёнок никогда не играет в карты",
      "eng": "Your child never plays cards",
      "regEng": "/(?:Your (?:child|kid) never plays cards)/gm"
    },
    {
      "rus": "Ваши дети никогда не играют в карты",
      "eng": "Your children never play cards",
      "regEng": "/(?:Your (?:children|kids) never play cards)/gm"
    },
    {
      "rus": "Этот человек редко смотрит такие шоу",
      "eng": "This person rarely watches such shows",
      "regEng": "/(?:This person (?:rarely|seldom) watches such shows)/gm"
    },
    {
      "rus": "Эти люди редко смотрят такие шоу",
      "eng": "These people rarely watch such shows"
    }
  ],
  [
    {
      "rus": "Он хочет найти новую работу",
      "eng": "He wants to find a new job"
    },
    {
      "rus": "Нам нравится смотреть эти чудесные фильмы",
      "eng": "We like to watch these wonderful films",
      "regEng": "/(?:We like to watch these wonderful (?:films|movies))/gm"
    },
    {
      "rus": "Чтобы зарабатывать деньги, тебе нужно работать",
      "eng": "To earn money you need to work",
      "regEng": "/(?:To earn money you need to work)|(?:You need to work to earn money)/gm"
    },
    {
      "rus": "Кто хочет услышать отличную историю?",
      "eng": "Who wants to hear an excellent story?"
    },
    {
      "rus": "Ей нужно взять ручку, чтобы писать",
      "eng": "She needs to take a pen to write",
      "regEng": "/(?:She needs to take a pen to write)|(?:To write she needs to take a pen)/gm"
    },
    {
      "rus": "Мне нужно видеть своих друзей каждый день",
      "eng": "I need to see my friends every day"
    }
  ],
  [
    {
      "rus": "Он знает каждую красивую девушку здесь",
      "eng": "He knows every beautiful girl here"
    },
    {
      "rus": "У меня есть хороший вопрос",
      "eng": "I have a good question"
    },
    {
      "rus": "Она хочет купить новые дорогие туфли",
      "eng": "She wants to buy new expensive shoes"
    },
    {
      "rus": "Нам всегда нравится слышать твои истории",
      "eng": "We always like to hear your stories"
    },
    {
      "rus": "Кому нужно играть в эти видеоигры?",
      "eng": "Who needs to play these video games?"
    },
    {
      "rus": "Мы знаем такой интересный фильм!",
      "eng": "We know such an interesting film!",
      "regEng": "/(?:We know such an interesting (?:film|movie)!)/gm"
    },
    {
      "rus": "Эти женщины редко носят такие брюки",
      "eng": "These women rarely wear such trousers",
      "regEng": "/(?:These women (?:rarely|seldom) wear such (?:trousers|pants))/gm"
    }
  ],
  [
    {
      "rus": "Мои дети никогда не смотрят телевизор",
      "eng": "My children never watch TV",
      "regEng": "/(?:My (?:children|kids) never watch TV)/gm"
    },
    {
      "rus": "Они никогда не слушают меня",
      "eng": "They never listen to me"
    },
    {
      "rus": "У кого есть зелёная ручка?",
      "eng": "Who has a green pen?"
    },
    {
      "rus": "Вам нужно приезжать сюда всё время",
      "eng": "You need to come here all the time"
    },
    {
      "rus": "Этот мужчина хочет поиграть в карты",
      "eng": "This man wants to play cards"
    },
    {
      "rus": "У вас удивительная работа",
      "eng": "You have an amazing job"
    },
    {
      "rus": "У этой женщины здоровые малыши",
      "eng": "This woman has healthy babies"
    },
    {
      "rus": "Ему нравится быть хорошим человеком",
      "eng": "He likes to be a good person"
    }
  ],
  [
    {
      "rus": "Этому человеку нужно, чтобы вы прочитали эти газеты",
      "eng": "This person needs you to read these newspapers"
    },
    {
      "rus": "Мой ребёнок хочет, чтобы я посмотрел те фильмы",
      "eng": "My child wants me to watch those films",
      "regEng": "/(?:My (?:child|kid) wants me to watch those (?:films|movies))/gm"
    },
    {
      "rus": "Женщины хотят, чтобы мужчины любили их",
      "eng": "Women want men to love them"
    },
    {
      "rus": "Мне нужно, чтобы ты увидел тех людей",
      "eng": "I need you to see those people"
    },
    {
      "rus": "Она хочет, чтобы я помог её детям",
      "eng": "She wants me to help her children",
      "regEng": "/(?:She wants me to help her (?:children|kids))/gm"
    },
    {
      "rus": "Нам нужно, чтобы он почистил свои зубы",
      "eng": "We need him to brush his teeth"
    }
  ],
  [
    {
      "rus": "Этим людям нужно, чтобы мы помыли свои ступни",
      "eng": "These people need us to wash our feet"
    },
    {
      "rus": "Этот мужчина хочет, чтобы она послушала ту песню",
      "eng": "This man wants her to listen to that song"
    },
    {
      "rus": "Родителям нужно, чтобы их дети чистили свои зубы",
      "eng": "Parents need their children to brush their teeth",
      "regEng": "/(?:Parents need their (?:children|kids) to brush their teeth)/gm"
    },
    {
      "rus": "Ему нужно, чтобы вы послушали его",
      "eng": "He needs you to listen to him"
    },
    {
      "rus": "Она хочет, чтобы я позвонил тому человеку",
      "eng": "She wants me to call that person",
      "regEng": "/(?:She wants me to (?:call|phone) that person)/gm"
    },
    {
      "rus": "Я хочу, чтобы они помыли свои ступни",
      "eng": "I want them to wash their feet"
    }
  ],
  [
    {
      "rus": "Он часто приносит ей цветы",
      "eng": "He often brings her flowers"
    },
    {
      "rus": "Вчера он принёс ей цветы",
      "eng": "Yesterday he brought her flowers",
      "regEng": "/(?:Yesterday he brought her flowers)|(?:He brought her flowers yesterday)/gm"
    },
    {
      "rus": "Завтра он принесёт ей цветы",
      "eng": "Tomorrow he will bring her flowers",
      "regEng": "/(?:Tomorrow (?:he will|he’ll) bring her flowers)|(?:(?:he will|he’ll) bring her flowers tomorrow)/gm"
    },
    {
      "rus": "Она иногда берёт мою ручку",
      "eng": "She sometimes takes my pen"
    },
    {
      "rus": "Вчера она взяла мою ручку",
      "eng": "Yesterday she took my pen",
      "regEng": "/(?:Yesterday she took my pen)|(?:She took my pen yesterday)/gm"
    },
    {
      "rus": "Завтра она возьмёт мою ручку",
      "eng": "Tomorrow she will take my pen",
      "regEng": "/(?:Tomorrow (?:she will|she’ll) take my pen)|(?:(?:she will|she’ll) take my pen tomorrow)/gm"
    }
  ],
  [
    {
      "rus": "Я пишу вам сообщения каждый день",
      "eng": "I write you messages every day",
      "regEng": "/(?:I write you messages every day)|(?:Every day I write you messages)/gm"
    },
    {
      "rus": "Вчера я написал вам сообщение",
      "eng": "Yesterday I wrote you a message",
      "regEng": "/(?:Yesterday I wrote you a message)|(?:I wrote you a message yesterday)/gm"
    },
    {
      "rus": "Завтра я напишу вам сообщение",
      "eng": "Tomorrow I will write you a message",
      "regEng": "/(?:Tomorrow (?:I will|I’ll) write you a message)|(?:(?:I will|I’ll) write you a message tomorrow)/gm"
    },
    {
      "rus": "Они редко играют в игры",
      "eng": "They rarely play games",
      "regEng": "/They (?:rarely|seldom) play games/gm"
    },
    {
      "rus": "Вчера они поиграли в игры",
      "eng": "Yesterday they played games",
      "regEng": "/(?:Yesterday they played games)|(?:They played games yesterday)/gm"
    },
    {
      "rus": "Завтра они поиграют в игры",
      "eng": "Tomorrow they will play games",
      "regEng": "/(?:Tomorrow (?:they will|they’ll) play games)|(?:(?:They will|They’ll) play games tomorrow)/gm"
    }
  ],
  [
    {
      "rus": "У нас всегда отличные вечеринки",
      "eng": "We always have excellent parties"
    },
    {
      "rus": "Вчера у нас была отличная вечеринка",
      "eng": "Yesterday we had an excellent party",
      "regEng": "/(?:Yesterday we had an excellent party)|(?:We had an excellent party yesterday)/gm"
    },
    {
      "rus": "Завтра у нас будет отличная вечеринка",
      "eng": "Tomorrow we will have an excellent party",
      "regEng": "/(?:Tomorrow (?:we will|we’ll) have an excellent party)|(?:(?:We will|We’ll) have an excellent party tomorrow)/gm"
    },
    {
      "rus": "Я прихожу сюда всё время",
      "eng": "I come here all the time",
      "regEng": "/(?:I come here all the time)|(?:All the time I come here)/gm"
    },
    {
      "rus": "Вчера я пришёл сюда",
      "eng": "Yesterday I came here",
      "regEng": "/(?:Yesterday I came here)|(?:I came here yesterday)/gm"
    },
    {
      "rus": "Завтра я приду сюда",
      "eng": "Tomorrow I will come here",
      "regEng": "/(?:Tomorrow (?:I will|I’ll) come here)|(?:(?:I will|I’ll) come here tomorrow)/gm"
    }
  ],
  [
    {
      "rus": "Ей нужно, чтобы я нашёл новую работу",
      "eng": "She needs me to find a new job",
      "regEng": ""
    },
    {
      "rus": "Я хочу, чтобы этот мужчина помог мне",
      "eng": "I want this man to help me",
      "regEng": ""
    },
    {
      "rus": "Этим женщинам нужно, чтобы вы послушали их",
      "eng": "These women need you to listen to them",
      "regEng": ""
    },
    {
      "rus": "Он хочет, чтобы его ребенок почистил свои зубы",
      "eng": "He wants his child to brush his teeth",
      "regEng": "/He wants his (?:child|kid) to brush his teeth/gm"
    },
    {
      "rus": "Нам нужно, чтобы этот человек дал нам хорошую идею",
      "eng": "We need this person to give us a good idea",
      "regEng": ""
    },
    {
      "rus": "Ваши дети хотят, чтобы вы поиграли с ними",
      "eng": "Your children want you to play with them",
      "regEng": "/Your (?:children|kids) want you to play with them/gm"
    }
  ],
  [
    {
      "rus": "Она часто покупает новые платья",
      "eng": "She often buys new dresses",
      "regEng": ""
    },
    {
      "rus": "Вчера она купила новое платье",
      "eng": "Yesterday she bought a new dress",
      "regEng": "/(?:Yesterday she bought a new dress)|(?:She bought a new dress yesterday)/gm"
    },
    {
      "rus": "Завтра она купит новое платье",
      "eng": "Tomorrow she will buy a new dress",
      "regEng": "/(?:Tomorrow (?:she will|she’ll) buy a new dress)/gm"
    },
    {
      "rus": "Мы читаем интересные газеты каждую неделю",
      "eng": "We read interesting newspapers every week",
      "regEng": "/(?:We read interesting newspapers every week)|(?:Every week we read interesting newspapers)/gm"
    },
    {
      "rus": "Вчера мы прочитали интересную газету",
      "eng": "Yesterday we read an interesting newspaper",
      "regEng": "/(?:Yesterday we read an interesting newspaper)|(?:We read an interesting newspaper yesterday)/gm"
    },
    {
      "rus": "Завтра мы прочитаем интересную газету",
      "eng": "Tomorrow we will read an interesting newspaper",
      "regEng": "/(?:Tomorrow (?:we will|we’ll) read an interesting newspaper)|(?:(?:We will|We’ll) read an interesting newspaper tomorrow)/gm"
    },
    {
      "rus": "Я всегда вижу этого человека здесь",
      "eng": "I always see this person here",
      "regEng": ""
    },
    {
      "rus": "Вчера я видел этого человека здесь",
      "eng": "Yesterday I saw this person here",
      "regEng": "/(?:Yesterday I saw this person here)|(?:I saw this person here yesterday)/gm"
    },
    {
      "rus": "Завтра я увижу этого человека здесь",
      "eng": "Tomorrow I will see this person here",
      "regEng": "/(?:Tomorrow (?:I will|I’ll) see this person here)|(?:(?:I will|I’ll) see this person here tomorrow)/gm"
    }
  ],
  [
    {
      "rus": "У этой семьи огромный дом",
      "eng": "This family has a huge house",
      "regEng": ""
    },
    {
      "rus": "У тебя такие белые зубы!",
      "eng": "You have such white teeth!",
      "regEng": ""
    },
    {
      "rus": "Они никогда не хотят слушать меня",
      "eng": "They never want to listen to me",
      "regEng": ""
    },
    {
      "rus": "Эти мальчики иногда приходят сюда, чтобы поиграть в футбол",
      "eng": "These boys sometimes come here to play football",
      "regEng": ""
    },
    {
      "rus": "Ей нравится посещать эти чудесные страны каждый год",
      "eng": "She likes to visit these wonderful countries every year",
      "regEng": "/(?:She likes to visit these wonderful countries every year)|(?:Every year she likes to visit these wonderful countries)/gm"
    },
    {
      "rus": "У кого есть сложный вопрос?",
      "eng": "Who has a difficult question?",
      "regEng": ""
    },
    {
      "rus": "Она часто пьёт зелёный чай",
      "eng": "She often drinks green tea",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "У меня есть отличный подарок для тебя",
      "eng": "I have an excellent present for you",
      "regEng": "/I have an excellent (?:present|gift) for you/gm"
    },
    {
      "rus": "Мужчины обычно смотрят такие фильмы",
      "eng": "Men usually watch such films",
      "regEng": "/Men usually watch such (?:films|movies)/gm"
    },
    {
      "rus": "Мне нужно знать ваши имена",
      "eng": "I need to know your names",
      "regEng": ""
    },
    {
      "rus": "Кто помнит ту красивую девушку?",
      "eng": "Who remembers that beautiful girl?",
      "regEng": ""
    },
    {
      "rus": "Эти дети редко играют в такие игры",
      "eng": "These children rarely play such games",
      "regEng": "/These (?:children|kids) (?:rarely|seldom) play such games/gm"
    },
    {
      "rus": "Я хочу дать вам простое решение",
      "eng": "I want to give you a simple solution",
      "regEng": ""
    },
    {
      "rus": "У него такие огромные ступни!",
      "eng": "He has such huge feet!",
      "regEng": ""
    },
    {
      "rus": "Нам нравится слушать эти чудесные слова",
      "eng": "We like to listen to these wonderful words",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Мне нужно, чтобы ты пошёл туда завтра",
      "eng": "I need you to go there tomorrow",
      "regEng": ""
    },
    {
      "rus": "Она хочет, чтобы мы купили ей новое платье",
      "eng": "She wants us to buy her a new dress",
      "regEng": ""
    },
    {
      "rus": "Детям нужно, чтобы их родители разговаривали с ними",
      "eng": "Children need their parents to talk to them",
      "regEng": "/(?:Children|Kids) need their parents to (?:talk|speak) (?:to|with) them/gm"
    },
    {
      "rus": "Мы хотим, чтобы вы показали нам ту картинку",
      "eng": "We want you to show us that picture",
      "regEng": ""
    },
    {
      "rus": "Ему нужно, чтобы этот человек пришёл сюда завтра",
      "eng": "He needs this person to come here tomorrow",
      "regEng": ""
    },
    {
      "rus": "Они хотят, чтобы я сделал это для них",
      "eng": "They want me to do it for them",
      "regEng": "/They want me to do (?:it|that) for them/gm"
    }
  ],
  [
    {
      "rus": "Я обычно прихожу сюда в понедельник, чтобы увидеть всех своих друзей",
      "eng": "I usually come here on Monday to see all my friends",
      "regEng": "/(?:I usually come here on Monday to see all my friends)|(?:On Monday I usually come here to see all my friends)|(?:I usually come here to see all my friends on Monday)/gm"
    },
    {
      "rus": "Я пришёл сюда в прошлый понедельник, чтобы увидеть всех своих друзей",
      "eng": "I came here last Monday to see all my friends",
      "regEng": "/(?:I came here last Monday to see all my friends)|(?:Last Monday I came here to see all my friends)|(?:I came here to see all my friends last Monday)/gm"
    },
    {
      "rus": "Я приду сюда в следующий понедельник, чтобы увидеть всех своих друзей",
      "eng": "I will come here next Monday to see all my friends",
      "regEng": ""
    },
    {
      "rus": "Мы всегда приносим тебе эти документы во вторник",
      "eng": "We always bring you these documents on Tuesday",
      "regEng": ""
    },
    {
      "rus": "Мы принесли тебе эти документы в прошлый вторник",
      "eng": "We brought you these documents last Tuesday",
      "regEng": ""
    },
    {
      "rus": "Мы принесём тебе эти документы в следующий вторник",
      "eng": "We will bring you these documents next Tuesday",
      "regEng": "/(?:We will|We’ll) bring you these documents next Tuesday/gm"
    }
  ],
  [
    {
      "rus": "Мы часто ездим в это место в феврале",
      "eng": "We often go to this place in February",
      "regEng": "/(?:We often go to this place in February)|(?:In February we often go to this place)/gm"
    },
    {
      "rus": "Мы съездили в это место в прошлом феврале",
      "eng": "We went to this place last February",
      "regEng": "/(?:We went to this place last February)|(?:Last February we went to this place)/gm"
    },
    {
      "rus": "Мы съездим в это место в следующем феврале",
      "eng": "We will go to this place next February",
      "regEng": "/(?:(?:We will|We’ll) go to this place next February)|(?:Next February (?:we will|we’ll) go to this place)/gm"
    },
    {
      "rus": "Он обычно ходит в музеи в январе",
      "eng": "He usually goes to museums in January",
      "regEng": "/(?:He usually goes to museums in January)|(?:In January he usually goes to museums)/gm"
    },
    {
      "rus": "Он сходил в этот музей в прошлом январе",
      "eng": "He went to this museum last January",
      "regEng": "/(?:He went to this museum last January)|(?:Last January he went to this museum)/gm"
    },
    {
      "rus": "Он сходит в этот музей в следующем январе",
      "eng": "He will go to this museum next January",
      "regEng": "/(?:He will|He’ll) go to this museum next January/gm"
    }
  ],
  [
    {
      "rus": "они всегда начинают новый проект весной",
      "eng": "They always start a new project in spring",
      "regEng": "/(?:They always (?:start|begin) a new project in spring)|(?:In spring they always (?:start|begin) a new project)/gm"
    },
    {
      "rus": "они начали новый проект прошлой весной",
      "eng": "They started a new project last spring",
      "regEng": "/(?:They (?:started|began) a new project last spring)|(?:Last spring they (?:started|began) a new project)/gm"
    },
    {
      "rus": "они начнут новый проект следующей весной",
      "eng": "They will start a new project next spring",
      "regEng": "/(?:(?:They will|They’ll) (?:start|begin) a new project next spring)|(?:Next spring (?:they will|they’ll) (?:start|begin) a new project)/gm"
    },
    {
      "rus": "они всегда заканчивают свою работу летом",
      "eng": "They always finish their work in summer",
      "regEng": "/(?:They always finish their work in summer)|(?:In summer they always finish their work)/gm"
    },
    {
      "rus": "они закончили свою работу прошлым летом",
      "eng": "They finished their work last summer",
      "regEng": "/(?:They finished their work last summer)|(?:Last summer they finished their work)/gm"
    },
    {
      "rus": "они закончат свою работу следующим летом",
      "eng": "They will finish their work next summer",
      "regEng": "/(?:(?:They will|They’ll) finish their work next summer)|(?:Next summer (?:they will|they’ll) finish their work)/gm"
    }
  ],
  [
    {
      "rus": "Она обычно ездит в этот город в пятницу",
      "eng": "She usually goes to this city on Friday",
      "regEng": "/(?:She usually goes to this city on Friday)|(?:On Friday she usually goes to this city)/gm"
    },
    {
      "rus": "Она поехала в этот город в прошлую пятницу",
      "eng": "She went to this city last Friday",
      "regEng": "/(?:She went to this city last Friday)|(?:Last Friday she went to this city)/gm"
    },
    {
      "rus": "Она поедет в этот город в следующую пятницу",
      "eng": "She will go to this city next Friday",
      "regEng": "/(?:(?:She will|She’ll) go to this city next Friday)|(?:Next Friday (?:she will|she’ll) go to this city)/gm"
    },
    {
      "rus": "Мы иногда играем в теннис в среду",
      "eng": "We sometimes play tennis on Wednesday",
      "regEng": "/(?:We sometimes play tennis on Wednesday)|(?:On Wednesday we sometimes play tennis)/gm"
    },
    {
      "rus": "Мы играли в теннис в прошлую среду",
      "eng": "We played tennis last Wednesday",
      "regEng": "/(?:We played tennis last Wednesday)|(?:Last Wednesday We played tennis)/gm"
    },
    {
      "rus": "Мы поиграем в теннис в следующую среду",
      "eng": "We will play tennis next Wednesday",
      "regEng": "/(?:(?:We will|We’ll) play tennis next Wednesday)|(?:Next Wednesday (?:we will|we’ll) play tennis)/gm"
    }
  ],
  [
    {
      "rus": "Я хочу, чтобы вы говорили по-английски",
      "eng": "I want you to speak English",
      "regEng": ""
    },
    {
      "rus": "Этим людям нужно, чтобы мы поговорили с ними",
      "eng": "These people need us to talk to them",
      "regEng": "/These people need us to (?:talk|speak) (?:to|with) them/gm"
    },
    {
      "rus": "Она хочет, чтобы я тренировался каждый день",
      "eng": "She wants me to exercise every day",
      "regEng": ""
    },
    {
      "rus": "Этому человеку нужно, чтобы они помнили те слова",
      "eng": "This person needs them to remember those words",
      "regEng": ""
    },
    {
      "rus": "Родители хотят, чтобы их дети ели хорошую еду",
      "eng": "Parents want their children to eat good food",
      "regEng": "/Parents want their (?:children|kids) to eat good food/gm"
    },
    {
      "rus": "Нам нужно, чтобы она слушала нас",
      "eng": "We need her to listen to us",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Он часто ездит в эти удивительные страны зимой",
      "eng": "He often goes to these amazing countries in winter",
      "regEng": "/(?:He often goes to these amazing countries in winter)|(?:In winter he often goes to these amazing countries)/gm"
    },
    {
      "rus": "Он съездил в эти удивительные страны прошлой зимой",
      "eng": "He went to these amazing countries last winter",
      "regEng": "/(?:He went to these amazing countries last winter)|(?:Last winter he went to these amazing countries)/gm"
    },
    {
      "rus": "Он съездит в эти удивительные страны следующей зимой",
      "eng": "He will go to these amazing countries next winter",
      "regEng": "/(?:(?:He will|He’ll) go to these amazing countries next winter)|(?:Next winter (?:he will|he’ll) go to these amazing countries)/gm"
    },
    {
      "rus": "Они всегда покупают интересные книги в июне",
      "eng": "They always buy interesting books in June",
      "regEng": "/(?:They always buy interesting books in June)|(?:In June they always buy interesting books)/gm"
    },
    {
      "rus": "Они купили интересную книгу в прошлом июне",
      "eng": "They bought an interesting book last June",
      "regEng": "/(?:They bought an interesting book last June)|(?:Last June they bought an interesting book)/gm"
    },
    {
      "rus": "Они купят интересную книгу в следующем июне",
      "eng": "They will buy an interesting book next June",
      "regEng": "/(?:They will buy an interesting book next June)|(?:Next June they will buy an interesting book)/gm"
    }
  ],
  [
    {
      "rus": "Я обычно ношу эти туфли в субботу",
      "eng": "I usually wear these shoes on Saturday",
      "regEng": "/(?:I usually wear these shoes on Saturday)|(?:On Saturday I usually wear these shoes)/gm"
    },
    {
      "rus": "Я носил эти туфли в прошлую субботу",
      "eng": "I wore these shoes last Saturday",
      "regEng": "/(?:I wore these shoes last Saturday)|(?:Last Saturday I wore these shoes)/gm"
    },
    {
      "rus": "Я буду носить эти туфли в следующую субботу",
      "eng": "I will wear these shoes next Saturday",
      "regEng": "/(?:(?:I will|I’ll) wear these shoes next Saturday)|(?:Next Saturday (?:I will|I’ll) wear these shoes)/gm"
    },
    {
      "rus": "Мы иногда ходим в такие чудесные места в четверг",
      "eng": "We sometimes go to such wonderful places on Thursday",
      "regEng": "/(?:We sometimes go to such wonderful places on Thursday)|(?:On Thursday we sometimes go to such wonderful places)/gm"
    },
    {
      "rus": "Мы ходили в такое чудесное место в прошлый четверг",
      "eng": "We went to such a wonderful place last Thursday",
      "regEng": "/(?:We went to such a wonderful place last Thursday)|(?:Last Thursday we went to such a wonderful place)/gm"
    },
    {
      "rus": "Мы пойдём в такое чудесное место в следующий четверг",
      "eng": "We will go to such a wonderful place next Thursday",
      "regEng": "/(?:We will go to such a wonderful place next Thursday)|(?:Next Thursday we will go to such a wonderful place)/gm"
    }
  ],
  [
    {
      "rus": "Завтра мы дадим вам отличную идею",
      "eng": "Tomorrow we will give you an excellent idea",
      "regEng": "/(?:Tomorrow we will give you an excellent idea)|(?:We will give you an excellent idea tomorrow)/gm"
    },
    {
      "rus": "Она никогда не носит длинных юбок",
      "eng": "She never wears long skirts",
      "regEng": ""
    },
    {
      "rus": "Мои друзья редко смотрят телевизор",
      "eng": "My friends rarely watch TV",
      "regEng": "/My friends (?:seldom|rarely) watch TV/gm"
    },
    {
      "rus": "Вчера он играл в теннис с моим сыном",
      "eng": "Yesterday he played tennis with my son",
      "regEng": "/(?:Yesterday he played tennis with my son)|(?:He played tennis with my son yesterday)/gm"
    },
    {
      "rus": "Мы хотим, чтобы они пришли сюда завтра",
      "eng": "We want them to come here tomorrow",
      "regEng": "/(?:We want them to come here tomorrow)|(?:Tomorrow we want them to come here)/gm"
    },
    {
      "rus": "У меня такая удивительная и счастливая жизнь!",
      "eng": "I have such an amazing and happy life!",
      "regEng": ""
    },
    {
      "rus": "Эти мужчины принесли те документы вчера",
      "eng": "These men brought those documents yesterday",
      "regEng": "/(?:These men brought those documents yesterday)|(?:Yesterday these men brought those documents)/gm"
    }
  ],
  [
    {
      "rus": "Мы никогда не пишем коротких писем",
      "eng": "We never write short letters",
      "regEng": ""
    },
    {
      "rus": "Они прочитали её важное сообщение вчера",
      "eng": "They read her important message yesterday",
      "regEng": "/(?:They read her important message yesterday)|(?:Yesterday they read her important message)/gm"
    },
    {
      "rus": "У этих женщин здоровые и красивые тела",
      "eng": "These women have healthy and beautiful bodies",
      "regEng": ""
    },
    {
      "rus": "У неё есть дорогое красное платье",
      "eng": "She has an expensive red dress",
      "regEng": ""
    },
    {
      "rus": "Я видел вашу дочь вчера",
      "eng": "I saw your daughter yesterday",
      "regEng": "/(?:I saw your daughter yesterday)|(?:Yesterday I saw your daughter)/gm"
    },
    {
      "rus": "Эта женщина всегда старается быть дружелюбной",
      "eng": "This woman always tries to be friendly",
      "regEng": ""
    },
    {
      "rus": "Вчера они купили новую большую сумку",
      "eng": "Yesterday they bought a new big bag",
      "regEng": "/(?:Yesterday they bought a new (?:big|large) bag)|(?:They bought a new (?:big|large) bag yesterday)/gm"
    },
    {
      "rus": "Этот ребёнок хочет найти новых друзей",
      "eng": "This child wants to find new friends",
      "regEng": "/This (?:child|kid) wants to find new friends/gm"
    }
  ],
  [
    {
      "rus": "В понедельник я обычно езжу на работу на автобусе",
      "eng": "On Monday I usually go to work by bus",
      "regEng": "/(?:On Monday I usually go to work by bus)|(?:I usually go to work by bus on Monday)/gm"
    },
    {
      "rus": "В прошлый понедельник я поехал на работу на такси",
      "eng": "Last Monday I went to work by taxi",
      "regEng": "/(?:Last Monday I went to work by taxi)|(?:I went to work by taxi last Monday)/gm"
    },
    {
      "rus": "В следующий понедельник я поеду на работу на поезде",
      "eng": "Next Monday I will go to work by train",
      "regEng": "/(?:Next Monday (?:I will|I’ll) go to work by train)|(?:(?:I will|I’ll) go to work by train next Monday)/gm"
    },
    {
      "rus": "В пятницу они редко ездят в больницу на трамвае",
      "eng": "On Friday they rarely go to hospital by tram",
      "regEng": "/(?:On Friday they (?:rarely|seldom) go to hospital by tram)|(?:They (?:rarely|seldom) go to hospital by tram on Friday)/gm"
    },
    {
      "rus": "В прошлую пятницу они поехали в больницу на велосипеде",
      "eng": "Last Friday they went to hospital by bicycle",
      "regEng": "/(?:Last Friday they went to hospital by bicycle)|(?:They went to hospital by bicycle last Friday)/gm"
    },
    {
      "rus": "В следующую пятницу они поедут в больницу на автобусе",
      "eng": "Next Friday they will go to hospital by bus",
      "regEng": "/(?:Next Friday (?:they will|They’ll) go to hospital by bus)|(?:(?:They will|They’ll) go to hospital by bus next Friday)/gm"
    }
  ],
  [
    {
      "rus": "Осенью она часто ездит в школу на машине",
      "eng": "In autumn she often goes to school by car",
      "regEng": "/(?:In autumn she often goes to school by car)|(?:She often goes to school by car in autumn)/gm"
    },
    {
      "rus": "Прошлой осенью она поехала в школу на велосипеде",
      "eng": "Last autumn she went to school by bicycle",
      "regEng": "/(?:Last autumn she went to school by bicycle)|(?:She went to school by bicycle last autumn)/gm"
    },
    {
      "rus": "Следующей осенью она поедет в школу на трамвае",
      "eng": "Next autumn she will go to school by tram",
      "regEng": "/(?:Next autumn (?:she will|she’ll) go to school by tram)|(?:(?:She will|She’ll) go to school by tram next autumn)/gm"
    },
    {
      "rus": "Весной вы всегда ездите в университет на поезде",
      "eng": "In spring you always go to university by train",
      "regEng": "/(?:In spring you always go to university by train)|(?:You always go to university by train In spring)/gm"
    },
    {
      "rus": "Прошлой весной вы пошли в университет пешком",
      "eng": "Last spring you went to university on foot",
      "regEng": "/(?:Last spring you went to university on foot)|(?:You went to university on foot last spring)/gm"
    },
    {
      "rus": "Следующей весной вы поедете в университет на такси",
      "eng": "Next spring you will go to university by taxi",
      "regEng": "/(?:Next spring (?:you will|you’ll) go to university by taxi)|(?:(?:You will|You’ll) go to university by taxi next spring)/gm"
    }
  ],
  [
    {
      "rus": "В июле мы иногда ездим домой на лодке",
      "eng": "In July we sometimes go home by boat",
      "regEng": "/(?:In July we sometimes go home by boat)|(?:We sometimes go home by boat in July)/gm"
    },
    {
      "rus": "В прошлом июле мы поехали домой на самолете",
      "eng": "Last July we went home by plane",
      "regEng": "/(?:Last July we went home by plane)|(?:We went home by plane last July)/gm"
    },
    {
      "rus": "В следующем июле мы пойдём домой пешком",
      "eng": "Next July we will go home on foot",
      "regEng": "/(?:Next July we will go home on foot)|(?:We will go home on foot next July)/gm"
    },
    {
      "rus": "В августе она всегда ездит домой на автобусе",
      "eng": "In August she always goes home by bus",
      "regEng": "/(?:In August she always goes home by bus)|(?:She always goes home by bus in August)/gm"
    },
    {
      "rus": "В прошлом августе она поехала домой на поезде",
      "eng": "Last August she went home by train",
      "regEng": "/(?:Last August she went home by train)|(?:She went home by train last August)/gm"
    },
    {
      "rus": "В следующем августе она поедет домой на велосипеде",
      "eng": "Next August she will go home by bicycle",
      "regEng": "/(?:Next August (?:she will|she’ll) go home by bicycle)|(?:(?:She will|She’ll) go home by bicycle next August)/gm"
    }
  ],
  [
    {
      "rus": "Ты обычно смотришь телевизор после работы",
      "eng": "You usually watch TV after work"
    },
    {
      "rus": "Ты не смотришь телевизор после работы",
      "eng": "You do not watch TV after work",
      "regEng": "/(?:You (?:do not|don’t) watch TV after work)/gm"
    },
    {
      "rus": "Смотришь ли ты телевизор после работы?",
      "eng": "Do you watch TV after work?"
    },
    {
      "rus": "Что ты делаешь после работы?",
      "eng": "What do you do after work?"
    },
    {
      "rus": "Она всегда читает книгу после школы",
      "eng": "She always reads a book after school"
    },
    {
      "rus": "Она не читает книгу после школы",
      "eng": "She does not read a book after school",
      "regEng": "/(?:She (?:does not|doesn’t) read a book after school)/gm"
    },
    {
      "rus": "Читает ли она книгу после школы?",
      "eng": "Does she read a book after school?"
    },
    {
      "rus": "Что она делает после школы?",
      "eng": "What does she do after school?"
    }
  ],
  [
    {
      "rus": "Вчера ты пришел домой рано",
      "eng": "Yesterday you came home early",
      "regEng": "/(?:Yesterday you came home early)|(?:You came home early yesterday)/gm"
    },
    {
      "rus": "Вчера ты не пришел домой рано",
      "eng": "Yesterday you did not come home early",
      "regEng": "/(?:Yesterday you (?:did not|didn’t) come home early)|(?:You (?:did not|didn’t) come home early yesterday)/gm"
    },
    {
      "rus": "Пришел ли ты домой рано вчера?",
      "eng": "Did you come home early yesterday?"
    },
    {
      "rus": "Когда ты пришел домой вчера?",
      "eng": "When did you come home yesterday?"
    },
    {
      "rus": "Вчера он выпил весь мой чай",
      "eng": "Yesterday he drank all my tea",
      "regEng": "/(?:Yesterday he drank all my tea)|(?:He drank all my tea yesterday)/gm"
    },
    {
      "rus": "Вчера он не выпил весь мой чай",
      "eng": "Yesterday he did not drink all my tea",
      "regEng": "/(?:Yesterday he (?:did not|didn’t) drink all my tea)|(?:He (?:did not|didn’t) drink all my tea yesterday)/gm"
    },
    {
      "rus": "Выпил ли он весь мой чай вчера?",
      "eng": "Did he drink all my tea yesterday?"
    },
    {
      "rus": "Что он сделал вчера?",
      "eng": "What did he do yesterday?"
    }
  ],
  [
    {
      "rus": "Завтра ты пойдешь в кровать поздно",
      "eng": "Tomorrow you will go to bed late",
      "regEng": "/(?:Tomorrow (?:you will|you’ll) go to bed late)|(?:(?:You will|You’ll) go to bed late tomorrow)/gm"
    },
    {
      "rus": "Завтра ты не пойдешь в кровать поздно",
      "eng": "Tomorrow you will not go to bed late",
      "regEng": "/(?:Tomorrow you (?:will not|won’t) go to bed late)|(?:You (?:will not|won’t) go to bed late tomorrow)/gm"
    },
    {
      "rus": "Пойдешь ли ты в кровать поздно завтра?",
      "eng": "Will you go to bed late tomorrow?"
    },
    {
      "rus": "Когда ты пойдешь в кровать завтра?",
      "eng": "When will you go to bed tomorrow?"
    },
    {
      "rus": "Завтра он позвонит своему другу",
      "eng": "Tomorrow he will call his friend",
      "regEng": "/(?:Tomorrow (?:he will|he’ll) call his friend)|(?:(?:He will|He’ll) call his friend tomorrow)/gm"
    },
    {
      "rus": "Завтра он не позвонит своему другу",
      "eng": "Tomorrow he will not call his friend",
      "regEng": "/(?:Tomorrow he (?:will not|won’t) call his friend)|(?:He (?:will not|won’t) call his friend tomorrow)/gm"
    },
    {
      "rus": "Позвонит ли он своему другу завтра?",
      "eng": "Will he call his friend tomorrow?"
    },
    {
      "rus": "Что он сделает завтра?",
      "eng": "What will he do tomorrow?"
    }
  ],
  [
    {
      "rus": "В среду я часто иду домой пешком",
      "eng": "On Wednesday I often go home on foot",
      "regEng": "/(?:On Wednesday I often go home on foot)|(?:I often go home on foot on Wednesday)/gm"
    },
    {
      "rus": "В прошлую среду я поехал домой на машине",
      "eng": "Last Wednesday I went home by car",
      "regEng": "/(?:Last Wednesday I went home by car)|(?:I went home by car last Wednesday)/gm"
    },
    {
      "rus": "В следующую среду я поеду домой на трамвае",
      "eng": "Next Wednesday I will go home by tram",
      "regEng": "/(?:Next Wednesday (?:I will|I’ll) go home by tram)|(?:(?:I will|I’ll) go home by tram next Wednesday)/gm"
    },
    {
      "rus": "В декабре они редко ездят на работу на велосипеде",
      "eng": "In December they rarely go to work by bicycle",
      "regEng": "/(?:In December they (?:rarely|seldom) go to work by bicycle)|(?:They (?:rarely|seldom) go to work by bicycle in December)/gm"
    },
    {
      "rus": "В прошлый декабрь они поехали на работу на самолете",
      "eng": "Last December they went to work by plane",
      "regEng": "/(?:Last December they went to work by (?:air)?plane)|(?:They went to work by (?:air)?plane Last December)/gm"
    },
    {
      "rus": "В следующий декабрь они поедут на работу на лодке",
      "eng": "Next December they will go to work by boat",
      "regEng": "/(?:Next December (?:they will|they’ll) go to work by boat)|(?:(?:They will|They’ll) go to work by boat Next December)/gm"
    },
    {
      "rus": "Летом она всегда ходит в колледж пешком",
      "eng": "In summer she always goes to college on foot",
      "regEng": "/(?:In summer she always goes to college on foot)|(?:She always goes to college on foot in summer)/gm"
    },
    {
      "rus": "Прошлым летом она поехала в колледж на такси",
      "eng": "Last summer she went to college by taxi",
      "regEng": "/(?:Last summer she went to college by taxi)|(?:She went to college by taxi last summer)/gm"
    },
    {
      "rus": "Следующим летом она поедет в колледж на поезде",
      "eng": "Next summer she will go to college by train",
      "regEng": "/(?:Next summer (?:she will|she’ll) go to college by train)|(?:(?:She will|She’ll) go to college by train next summer)/gm"
    }
  ],
  [
    {
      "rus": "Она часто тренируется перед работой",
      "eng": "She often exercises before work"
    },
    {
      "rus": "Она не тренируется перед работой",
      "eng": "She does not exercise before work",
      "regEng": "/(?:She (?:does not|doesn’t) exercise before work)/gm"
    },
    {
      "rus": "Тренируется ли она перед работой?",
      "eng": "Does she exercise before work?"
    },
    {
      "rus": "Что она делает перед работой?",
      "eng": "What does she do before work?"
    },
    {
      "rus": "Вчера они съели все ваши пирожные",
      "eng": "Yesterday they ate all your cakes",
      "regEng": "/(?:Yesterday they ate all your cakes)|(?:They ate all your cakes yesterday)/gm"
    },
    {
      "rus": "Вчера они не съели все ваши пирожные",
      "eng": "Yesterday they did not eat all your cakes",
      "regEng": "/(?:Yesterday they (?:did not|didn’t) eat all your cakes)|(?:They (?:did not|didn’t) eat all your cakes yesterday)/gm"
    },
    {
      "rus": "Съели ли они все ваши пирожные вчера?",
      "eng": "Did they eat all your cakes yesterday?"
    },
    {
      "rus": "Когда они съели все ваши пирожные?",
      "eng": "When did they eat all your cakes?"
    }
  ],
  [
    {
      "rus": "Вы принесёте ему эти документы завтра",
      "eng": "You will bring him these documents tomorrow",
      "regEng": "/(?:(?:You will|You’ll) bring him these documents tomorrow)|(?:Tomorrow (?:you will|you’ll) bring him these documents)/gm"
    },
    {
      "rus": "Вы не принесёте ему эти документы завтра",
      "eng": "You will not bring him these documents tomorrow",
      "regEng": "/(?:You (?:will not|won’t) bring him these documents tomorrow)|(?:Tomorrow you (?:will not|won’t) bring him these documents)/gm"
    },
    {
      "rus": "Принесёте ли вы ему эти документы завтра?",
      "eng": "Will you bring him these documents tomorrow?"
    },
    {
      "rus": "Что вы принесёте ему завтра?",
      "eng": "What will you bring him tomorrow?"
    },
    {
      "rus": "Вы взяли мою машину вчера",
      "eng": "You took my car yesterday",
      "regEng": "/(?:You took my car yesterday)|(?:Yesterday you took my car)/gm"
    },
    {
      "rus": "Вы не взяли мою машину вчера",
      "eng": "You did not take my car yesterday",
      "regEng": "/(?:You (?:did not|didn’t) take my car yesterday)|(?:Yesterday you (?:did not|didn’t) take my car)/gm"
    },
    {
      "rus": "Взяли ли вы мою машину вчера?",
      "eng": "Did you take my car yesterday?"
    },
    {
      "rus": "Когда вы взяли мою машину?",
      "eng": "When did you take my car?"
    }
  ],
  [
    {
      "rus": "Этот мальчик тренируется каждый день",
      "eng": "This boy exercises every day",
      "regEng": "/(?:This boy exercises every day)|(?:Every day this boy exercises)/gm"
    },
    {
      "rus": "Мы съездили в эту страну в прошлом году",
      "eng": "We went to this country last year",
      "regEng": "/(?:We went to this country last year)|(?:Last year we went to this country)/gm"
    },
    {
      "rus": "У её сестры есть маленькая проблема",
      "eng": "Her sister has a little problem",
      "regEng": "/(?:Her sister has a (?:little|small) problem)/gm"
    },
    {
      "rus": "Наши люди закончили этот проект в прошлом месяце",
      "eng": "Our people finished this project last month",
      "regEng": "/(?:Our people finished this project last month)|(?:Last month our people finished this project)/gm"
    },
    {
      "rus": "Мы посмотрели эти фильмы в прошлую пятницу",
      "eng": "We watched these films last Friday",
      "regEng": "/(?:We watched these films last Friday)|(?:Last Friday we watched these films)/gm"
    },
    {
      "rus": "Ей нужно, чтобы они зарабатывали деньги",
      "eng": "She needs them to earn money"
    },
    {
      "rus": "Мы видели твою сестру здесь в прошлом месяце",
      "eng": "We saw your sister here last month",
      "regEng": "/(?:We saw your sister here last month)|(?:Last month we saw your sister here)/gm"
    }
  ],
  [
    {
      "rus": "Он хочет иметь хороших друзей и большую семью",
      "eng": "He wants to have good friends and a big family",
      "regEng": "/(?:He wants to have good friends and a big family)|(?:He wants to have a big family and good friends)/gm"
    },
    {
      "rus": "Мне нужно прочитать их сообщения в четверг",
      "eng": "I need to read their messages on Thursday",
      "regEng": "/(?:I need to read their messages on Thursday)|(?:On Thursday I need to read their messages)/gm"
    },
    {
      "rus": "Вчера мы решили купить новый дом",
      "eng": "Yesterday we decided to buy a new house",
      "regEng": "/(?:Yesterday we decided to buy a new house)|(?:We decided to buy a new house yesterday)/gm"
    },
    {
      "rus": "У меня есть отличное решение",
      "eng": "I have an excellent solution"
    },
    {
      "rus": "Она поговорит с ними на следующей неделе",
      "eng": "She will talk to them next week",
      "regEng": "/(?:(?:She will|She’ll) talk (?:to|with) them next week)|(?:Next week (?:she will|she’ll) talk (?:to|with) them)/gm"
    },
    {
      "rus": "У вашего брата уродливые зубы",
      "eng": "Your brother has ugly teeth"
    },
    {
      "rus": "Они хотят, чтобы я знал этих людей",
      "eng": "They want me to know these people"
    },
    {
      "rus": "У этого малыша были огромные глаза",
      "eng": "This baby had huge eyes"
    }
  ],
  [
    {
      "rus": "Она часто завтракает поздно в субботу",
      "eng": "She often has breakfast late on Saturday",
      "regEng": "/(?:She often has breakfast late on Saturday)|(?:On Saturday she often has breakfast late)/gm"
    },
    {
      "rus": "Она не часто завтракает поздно в субботу",
      "eng": "She does not often have breakfast late on Saturday",
      "regEng": "/(?:She (?:does not|doesn’t) often have breakfast late on Saturday)|(?:On Saturday she (?:does not|doesn’t) often have breakfast late)/gm"
    },
    {
      "rus": "Завтракает ли она часто поздно в субботу?",
      "eng": "Does she often have breakfast late on Saturday?"
    },
    {
      "rus": "Почему она часто завтракает поздно в субботу?",
      "eng": "Why does she often have breakfast late on Saturday?"
    },
    {
      "rus": "Они всегда ужинают рано в воскресенье",
      "eng": "They always have dinner early on Sunday",
      "regEng": "/(?:They always have dinner early on Sunday)|(?:On Sunday they always have dinner early)/gm"
    },
    {
      "rus": "Они не всегда ужинают рано в воскресенье",
      "eng": "They do not always have dinner early on Sunday",
      "regEng": "/(?:They (?:do not|don’t) always have dinner early on Sunday)|(?:On Sunday they (?:do not|don’t) always have dinner early)/gm"
    },
    {
      "rus": "Ужинают ли они всегда рано в воскресенье?",
      "eng": "Do they always have dinner early on Sunday?"
    },
    {
      "rus": "Почему они всегда ужинают рано в воскресенье?",
      "eng": "Why do they always have dinner early on Sunday?"
    }
  ],
  [
    {
      "rus": "Они пообедали час назад",
      "eng": "They had lunch an hour ago",
      "regEng": "/(?:They had lunch an hour ago)|(?:An hour ago they had lunch)/gm"
    },
    {
      "rus": "Они не пообедали час назад",
      "eng": "They did not have lunch an hour ago",
      "regEng": "/(?:They (?:did not|didn’t) have lunch an hour ago)|(?:An hour ago they (?:did not|didn’t) have lunch)/gm"
    },
    {
      "rus": "Пообедали ли они час назад?",
      "eng": "Did they have lunch an hour ago?"
    },
    {
      "rus": "Когда они пообедали?",
      "eng": "When did they have lunch?"
    },
    {
      "rus": "Она поехала на работу на машине час назад",
      "eng": "She went to work by car an hour ago",
      "regEng": "/(?:She went to work by car an hour ago)|(?:An hour ago she went to work by car)/gm"
    },
    {
      "rus": "Она не поехала на работу на машине час назад",
      "eng": "She did not go to work by car an hour ago",
      "regEng": "/(?:She (?:did not|didn’t) go to work by car an hour ago)|(?:An hour ago she (?:did not|didn’t) go to work by car)/gm"
    },
    {
      "rus": "Поехала ли она на работу на машине час назад?",
      "eng": "Did she go to work by car an hour ago?"
    },
    {
      "rus": "Когда она поехала на работу на машине?",
      "eng": "When did she go to work by car?"
    }
  ],
  [
    {
      "rus": "Они обычно ужинают со своими коллегами в четверг",
      "eng": "They usually have dinner with their colleagues on Thursday",
      "regEng": "/(?:They usually have dinner with their colleagues on Thursday)|(?:On Thursday they usually have dinner with their colleagues)/gm"
    },
    {
      "rus": "Они обычно не ужинают со своими коллегами в четверг",
      "eng": "They do not usually have dinner with their colleagues on Thursday",
      "regEng": "/(?:They (?:do not|don’t) usually have dinner with their colleagues on Thursday)|(?:On Thursday they (?:do not|don’t) usually have dinner with their colleagues)/gm"
    },
    {
      "rus": "Ужинают ли они обычно со своими коллегами в четверг?",
      "eng": "Do they usually have dinner with their colleagues on Thursday?"
    },
    {
      "rus": "С кем они обычно ужинают в четверг?",
      "eng": "Who do they usually have dinner with on Thursday?",
      "regEng": "/(?:(?:Whom|Who|With whom) do they usually have dinner with on Thursday\\?)/gm"
    },
    {
      "rus": "Она всегда слушает эти песни в среду",
      "eng": "She always listens to these songs on Wednesday",
      "regEng": "/(?:She always listens to these songs on Wednesday)|(?:On Wednesday she always listens to these songs)/gm"
    },
    {
      "rus": "Она не всегда слушает эти песни в среду",
      "eng": "She does not always listen to these songs on Wednesday",
      "regEng": "/(?:She (?:does not|doesn’t) always listen to these songs on Wednesday)|(?:On Wednesday she (?:does not|doesn’t) always listen to these songs)/gm"
    },
    {
      "rus": "Слушает ли она всегда эти песни в среду?",
      "eng": "Does she always listen to these songs on Wednesday?"
    },
    {
      "rus": "Что она всегда слушает в среду?",
      "eng": "What does she always listen to on Wednesday?"
    }
  ],
  [
    {
      "rus": "Он поговорит со своим другом через неделю",
      "eng": "He will talk to his friend in a week",
      "regEng": "/(?:(?:He will|He’ll) (?:talk|speak) (?:to|with) his friend in a week)|(?:In a week (?:he will|he’ll) (?:talk|speak) (?:to|with) his friend)/gm"
    },
    {
      "rus": "Он не поговорит со своим другом через неделю",
      "eng": "He will not talk to his friend in a week",
      "regEng": "/(?:He(?: will not|’ll not| won’t) (?:talk|speak) (?:to|with) his friend in a week)|(?:In a week he(?: will not|’ll not| won’t) (?:talk|speak) (?:to|with) his friend)/gm"
    },
    {
      "rus": "Поговорит ли он со своим другом через неделю?",
      "eng": "Will he talk to his friend in a week?",
      "regEng": "/(?:Will he (?:talk|speak) (?:to|with) his friend in a week\\?)/gm"
    },
    {
      "rus": "С кем он поговорит через неделю?",
      "eng": "Who will he talk to in a week?",
      "regEng": "/(?:Whom? will he (?:talk|speak) (?:to|with) in a week\\?)/gm"
    },
    {
      "rus": "Мы подумаем об этой идее через неделю",
      "eng": "We will think about this idea in a week",
      "regEng": "/(?:(?:We will|We’ll) think about this idea in a week)|(?:In a week (?:we will|we’ll) think about this idea)/gm"
    },
    {
      "rus": "Мы не подумаем об этой идее через неделю",
      "eng": "We will not think about this idea in a week",
      "regEng": "/(?:We(?: will not|’ll not| won’t) think about this idea in a week)|(?:In a week we(?: will not|’ll not| won’t) think about this idea)/gm"
    },
    {
      "rus": "Подумаем ли мы об этой идее через неделю?",
      "eng": "Will we think about this idea in a week?"
    },
    {
      "rus": "О чём мы подумаем через неделю?",
      "eng": "What will we think about in a week?"
    }
  ],
  [
    {
      "rus": "Мы часто ищем интересные книги здесь",
      "eng": "We often look for interesting books here",
      "regEng": "/(?:We often (?:look|search) for interesting books here)/gm"
    },
    {
      "rus": "Мы не часто ищем интересные книги здесь",
      "eng": "We do not often look for interesting books here",
      "regEng": "/(?:We (?:do not|don’t) often (?:look|search) for interesting books here)/gm"
    },
    {
      "rus": "Ищем ли мы часто интересные книги здесь?",
      "eng": "Do we often look for interesting books here?",
      "regEng": "/(?:Do we often (?:look|search) for interesting books here\\?)/gm"
    },
    {
      "rus": "Что мы часто ищем здесь?",
      "eng": "What do we often look for here?",
      "regEng": "/(?:What do we often (?:look|search) for here\\?)/gm"
    },
    {
      "rus": "Он обычно ходит туда со своими родителями",
      "eng": "He usually goes there with his parents."
    },
    {
      "rus": "Он обычно не ходит туда со своими родителями",
      "eng": "He does not usually go there with his parents",
      "regEng": "/(?:He (?:does not|doesn’t) usually go there with his parents)/gm"
    },
    {
      "rus": "Ходит ли он обычно туда со своими родителями?",
      "eng": "Does he usually go there with his parents?"
    },
    {
      "rus": "С кем он обычно ходит туда?",
      "eng": "Who does he usually go there with?"
    }
  ],
  [
    {
      "rus": "Они иногда обедают здесь во вторник",
      "eng": "They sometimes have lunch here on Tuesday",
      "regEng": "/(?:They sometimes have lunch here on Tuesday)|(?:On Tuesday they sometimes have lunch here)/gm"
    },
    {
      "rus": "Они не обедают здесь во вторник",
      "eng": "They do not have lunch here on Tuesday",
      "regEng": "/(?:They (?:do not|don’t) have lunch here on Tuesday)|(?:On Tuesday they (?:do not|don’t) have lunch here)/gm"
    },
    {
      "rus": "Обедают ли они иногда здесь во вторник?",
      "eng": "Do they sometimes have lunch here on Tuesday?"
    },
    {
      "rus": "Почему они иногда обедают здесь во вторник?",
      "eng": "Why do they sometimes have lunch here on Tuesday?"
    },
    {
      "rus": "Он часто ужинает там в понедельник",
      "eng": "He often has dinner there on Monday"
    },
    {
      "rus": "Он не часто ужинает там в понедельник",
      "eng": "He does not often have dinner there on Monday",
      "regEng": "/(?:He (?:does not|doesn’t) often have dinner there on Monday)|(?:On Monday he (?:does not|doesn’t) often have dinner there)/gm"
    },
    {
      "rus": "Ужинает ли он там часто в понедельник?",
      "eng": "Does he often have dinner there on Monday?"
    },
    {
      "rus": "Почему он часто ужинает там в понедельник?",
      "eng": "Why does he often have dinner there on Monday?"
    }
  ],
  [
    {
      "rus": "Они поехали домой на поезде месяц назад",
      "eng": "They went home by train a month ago",
      "regEng": "/(?:They went home by train a month ago)|(?:A month ago they went home by train)/gm"
    },
    {
      "rus": "Они не поехали домой на поезде месяц назад",
      "eng": "They did not go home by train a month ago",
      "regEng": "/(?:They (?:did not|didn’t) go home by train a month ago)|(?:A month ago they (?:did not|didn’t) go home by train)/gm"
    },
    {
      "rus": "Поехали ли они домой на поезде месяц назад?",
      "eng": "Did they go home by train a month ago?"
    },
    {
      "rus": "Когда они поехали домой на поезде?",
      "eng": "When did they go home by train?"
    },
    {
      "rus": "Мы позавтракаем с вами через час",
      "eng": "We will have breakfast with you in an hour",
      "regEng": "/(?:(?:We will|We’ll) have breakfast with you in an hour)|(?:In an hour (?:we will|we’ll) have breakfast with you)/gm"
    },
    {
      "rus": "Мы не позавтракаем с вами через час",
      "eng": "We will not have breakfast with you in an hour",
      "regEng": "/(?:We (?:will not|won’t) have breakfast with you in an hour)|(?:In an hour we (?:will not|won’t) have breakfast with you)/gm"
    },
    {
      "rus": "Позавтракаем ли мы с вами через час?",
      "eng": "Will we have breakfast with you in an hour?"
    },
    {
      "rus": "С кем мы позавтракаем через час?",
      "eng": "Who will we have breakfast with in an hour?",
      "regEng": "/(?:Whom? will we have breakfast with in an hour\\?)|(?:With whom will we have breakfast in an hour\\?)/gm"
    }
  ],
  [
    {
      "rus": "Мы часто говорим об этом бизнесе",
      "eng": "We often talk about this business",
      "regEng": "/(?:We often (?:talk|speak) about this business)/gm"
    },
    {
      "rus": "Мы не часто говорим об этом бизнесе",
      "eng": "We do not often talk about this business",
      "regEng": "/(?:We (?:do not|don’t) often (?:talk|speak) about this business)/gm"
    },
    {
      "rus": "Говорим ли мы часто об этом бизнесе?",
      "eng": "Do we often talk about this business?",
      "regEng": "/(?:Do we often (?:talk|speak) about this business\\?)/gm"
    },
    {
      "rus": "О чём мы часто говорим?",
      "eng": "What do we often talk about?",
      "regEng": "/(?:What do we often (?:talk|speak) about\\?)/gm"
    },
    {
      "rus": "Вы послушали эту песню неделю назад",
      "eng": "You listened to this song a week ago",
      "regEng": "/(?:You listened to this song a week ago)|(?:A week ago You listened to this song)/gm"
    },
    {
      "rus": "Вы не послушали эту песню неделю назад",
      "eng": "You did not listen to this song a week ago",
      "regEng": "/(?:You (?:did not|didn’t) listen to this song a week ago)|(?:A week ago you (?:did not|didn’t) listen to this song)/gm"
    },
    {
      "rus": "Послушали ли вы эту песню неделю назад?",
      "eng": "Did you listen to this song a week ago?"
    },
    {
      "rus": "Что вы послушали неделю назад?",
      "eng": "What did you listen to a week ago?"
    }
  ],
  [
    {
      "rus": "Она поедет туда со своей сестрой через месяц",
      "eng": "She will go there with her sister in a month",
      "regEng": "/(?:(?:She will|She’ll) go there with her sister in a month)|(?:In a month (?:she will|she’ll) go there with her sister)/gm"
    },
    {
      "rus": "Она не поедет туда со своей сестрой через месяц",
      "eng": "She will not go there with her sister in a month",
      "regEng": "/(?:She (?:will not|won’t) go there with her sister in a month)|(?:In a month she (?:will not|won’t) go there with her sister)/gm"
    },
    {
      "rus": "Поедет ли она туда со своей сестрой через месяц?",
      "eng": "Will she go there with her sister in a month?"
    },
    {
      "rus": "С кем она поедет туда через месяц?",
      "eng": "Who will she go there with in a month?",
      "regEng": "/(?:Whom? will she go there with in a month\\?)|(?:With whom will she go there in a month\\?)/gm"
    },
    {
      "rus": "Он всегда ждёт этих вечеринок",
      "eng": "He always waits for these parties"
    },
    {
      "rus": "Он не всегда ждёт этих вечеринок",
      "eng": "He does not always wait for these parties",
      "regEng": "/(?:He (?:does not|doesn’t) always wait for these parties)/gm"
    },
    {
      "rus": "Ждёт ли он всегда этих вечеринок?",
      "eng": "Does he always wait for these parties?"
    },
    {
      "rus": "Чего он всегда ждёт?",
      "eng": "What does he always wait for?"
    }
  ],
  [
    {
      "rus": "Мы приехали сюда в прошлом месяце",
      "eng": "We came here last month",
      "regEng": "/(?:We came here last month)|(?:Last month we came here)/gm"
    },
    {
      "rus": "Завтра я попытаюсь закончить это упражнение",
      "eng": "Tomorrow I will try to finish this exercise",
      "regEng": "/(?:Tomorrow (?:I will|I’ll) try to finish this exercise)|(?:(?:I will|I’ll) try to finish this exercise tomorrow)/gm"
    },
    {
      "rus": "Когда он принёс эти цветы?",
      "eng": "When did he bring these flowers?"
    },
    {
      "rus": "Вы никогда не говорите об этом",
      "eng": "You never talk about it",
      "regEng": "/(?:You never (?:talk|speak) about (?:it|this|that))|(?:You do not ever (?:talk|speak) about (?:it|this|that))|(?:You do not (?:talk|speak) about (?:it|this|that) ever)/gm"
    },
    {
      "rus": "Эти женщины кушают такие вкусные пирожные всё время",
      "eng": "These women eat such tasty cakes all the time",
      "regEng": "/(?:These women eat such tasty cakes all the time)|(?:All the time these women eat such tasty cakes)/gm"
    },
    {
      "rus": "Мы прочитали эту газету вчера",
      "eng": "We read this newspaper yesterday",
      "regEng": "/(?:We read this newspaper yesterday)|(?:Yesterday we read this newspaper)/gm"
    },
    {
      "rus": "Что она думает об этой проблеме?",
      "eng": "What does she think about this problem?"
    }
  ],
  [
    {
      "rus": "Мне нужно, чтобы вы показали мне эти журналы",
      "eng": "I need you to show me these magazines"
    },
    {
      "rus": "Она пьёт этот вкусный кофе каждое утро",
      "eng": "She drinks this tasty coffee every morning",
      "regEng": "/(?:She drinks this tasty coffee every morning)|(?:Every morning she drinks this tasty coffee)/gm"
    },
    {
      "rus": "Ей нравится шоколад?",
      "eng": "Does she like chocolate?"
    },
    {
      "rus": "Мы посетим такое интересное место в следующем году",
      "eng": "We will visit such an interesting place next year",
      "regEng": "/(?:(?:We will|We’ll) visit such an interesting place next year)|(?:Next year (?:we will|we’ll) visit such an interesting place)/gm"
    },
    {
      "rus": "Они подарили мне удивительный подарок на прошлой неделе",
      "eng": "They gave me an amazing present last week",
      "regEng": "/(?:They gave me an amazing (?:present|gift) last week)|(?:Last week they gave me an amazing (?:present|gift))/gm"
    },
    {
      "rus": "Я слышал ту песню в прошлом году",
      "eng": "I heard that song last year",
      "regEng": "/(?:I heard that song last year)|(?:Last year I heard that song)/gm"
    },
    {
      "rus": "Ты знаешь тех людей?",
      "eng": "Do you know those people?"
    },
    {
      "rus": "Вы разговариваете со своими коллегами каждый понедельник",
      "eng": "You talk to your colleagues every Monday",
      "regEng": "/(?:You (?:talk|speak) (?:to|with) your colleagues every Monday)|(?:Every Monday you (?:talk|speak) (?:to|with) your colleagues)/gm"
    }
  ],
  [
    {
      "rus": "У неё красивая дочка",
      "eng": "She has a beautiful daughter"
    },
    {
      "rus": "Они играют в теннис каждый день",
      "eng": "They play tennis every day",
      "regEng": "/(?:They play tennis every day)|(?:Every day they play tennis)/gm"
    },
    {
      "rus": "Он хочет прочитать эту книгу",
      "eng": "He wants to read this book"
    },
    {
      "rus": "Он всегда носит короткие брюки",
      "eng": "He always wears short trousers"
    },
    {
      "rus": "Нам нужно, чтобы вы посмотрели эти фильмы",
      "eng": "We need you to watch these films"
    },
    {
      "rus": "Вчера она купила новое платье",
      "eng": "Yesterday she bought a new dress",
      "regEng": "/(?:Yesterday she bought a new dress)|(?:She bought a new dress yesterday)/gm"
    },
    {
      "rus": "У нас хорошие друзья",
      "eng": "We have good friends"
    },
    {
      "rus": "Я позвоню тебе в понедельник",
      "eng": "I will call you on Monday",
      "regEng": "/(?:(?:I will|I’ll) call you on Monday)|(?:On Monday (?:I will|I’ll) call you)/gm"
    },
    {
      "rus": "Они хотят, чтобы я помог им",
      "eng": "They want me to help them"
    },
    {
      "rus": "Мы закончили этот проект в прошлом месяце",
      "eng": "We finished this project last month",
      "regEng": "/(?:We finished this project last month)|(?:Last month we finished this project)/gm"
    },
    {
      "rus": "Мне нужно, чтобы вы написали мне сообщение",
      "eng": "I need you to write me a message"
    },
    {
      "rus": "Вчера она поехала в школу на автобусе",
      "eng": "Yesterday she went to school by bus",
      "regEng": "/(?:Yesterday she went to school by bus)|(?:She went to school by bus yesterday)/gm"
    },
    {
      "rus": "Мы обычно ездим на работу на машине",
      "eng": "We usually go to work by car"
    },
    {
      "rus": "Они видели его здесь в среду",
      "eng": "They saw him here on Wednesday",
      "regEng": "/(?:They saw him here on Wednesday)|(?:On Wednesday they saw him here)/gm"
    },
    {
      "rus": "Я люблю свою чудесную жизнь!",
      "eng": "I love my wonderful life!"
    }
  ],
  [
    {
      "rus": "Час назад мы поговорили о погоде",
      "eng": "An hour ago we talked about weather",
      "regEng": "/(?:An hour ago we (?:talked|spoke) about weather)|(?:We (?:talked|spoke) about weather an hour ago)/gm"
    },
    {
      "rus": "Час назад мы не поговорили о погоде",
      "eng": "An hour ago we did not talk about weather",
      "regEng": "/(?:An hour ago we (?:did not|didn’t) (?:talk|speak) about weather)|(?:We (?:did not|didn’t) (?:talk|speak) about weather an hour ago)/gm"
    },
    {
      "rus": "Поговорили ли мы о погоде час назад?",
      "eng": "Did we talk about weather an hour ago?",
      "regEng": "/(?:Did we (?:talk|speak) about weather an hour ago\\?)/gm"
    },
    {
      "rus": "О чём мы поговорили час назад?",
      "eng": "What did we talk about an hour ago?",
      "regEng": "/(?:What did we (?:talk|speak) about an hour ago\\?)/gm"
    },
    {
      "rus": "Неделю назад вы поговорили со своим братом",
      "eng": "A week ago you talked to your brother",
      "regEng": "/(?:A week ago you (?:talked|spoke) (?:to|with) your brother)|(?:You (?:talked|spoke) (?:to|with) your brother a week ago)/gm"
    },
    {
      "rus": "Неделю назад вы не поговорили со своим братом",
      "eng": "A week ago you did not talk to your brother",
      "regEng": "/(?:A week ago you (?:did not|didn’t) (?:talk|speak) (?:to|with) your brother)|(?:You (?:did not|didn’t) (?:talk|speak) (?:to|with) your brother a week ago)/gm"
    },
    {
      "rus": "Поговорили ли вы со своим братом неделю назад?",
      "eng": "Did you talk to your brother a week ago?",
      "regEng": "/(?:Did you (?:talk|speak) (?:to|with) your brother a week ago\\?)/gm"
    },
    {
      "rus": "С кем вы поговорили неделю назад?",
      "eng": "Who did you talk to a week ago?",
      "regEng": "/(?:Who did you (?:talk|speak) (?:to|with) a week ago\\?)/gm"
    }
  ],
  [
    {
      "rus": "Они часто слушают этих людей",
      "eng": "They often listen to these people"
    },
    {
      "rus": "Они не часто слушают этих людей",
      "eng": "They do not often listen to these people",
      "regEng": "/(?:They (?:do not|don’t) often listen to these people)/gm"
    },
    {
      "rus": "Слушают ли они часто этих людей?",
      "eng": "Do they often listen to these people?"
    },
    {
      "rus": "Кого они часто слушают?",
      "eng": "Who do they often listen to?",
      "regEng": "/(?:(?:Who|whom|to whom) do they often listen to\\?)/gm"
    },
    {
      "rus": "Она всегда слушает такую музыку",
      "eng": "She always listens to such music"
    },
    {
      "rus": "Она не всегда слушает такую музыку",
      "eng": "She does not always listen to such music",
      "regEng": "/(?:She (?:does not|doesn’t) always listen to such music)/gm"
    },
    {
      "rus": "Слушает ли она всегда такую музыку?",
      "eng": "Does she always listen to such music?"
    },
    {
      "rus": "Что она всегда слушает?",
      "eng": "What does she always listen to?"
    }
  ],
  [
    {
      "rus": "Мы поедем туда с нашими коллегами через месяц",
      "eng": "We will go there with our colleagues in a month",
      "regEng": "/(?:(?:We will|We’ll) go there with our colleagues in a month)|(?:In a month (?:we will|we’ll) go there with our colleagues)/gm"
    },
    {
      "rus": "Мы не поедем туда с нашими коллегами через месяц",
      "eng": "We will not go there with our colleagues in a month",
      "regEng": "/(?:We (?:will not|won’t) go there with our colleagues in a month)|(?:In a month we (?:will not|won’t) go there with our colleagues in a month)/gm"
    },
    {
      "rus": "Поедем ли мы туда с нашими коллегами через месяц?",
      "eng": "Will we go there with our colleagues in a month?"
    },
    {
      "rus": "С кем мы поедем туда через месяц?",
      "eng": "Who will we go there with in a month?",
      "regEng": "/(?:(?:Who|Whom) will we go there with in a month\\?)|(?:With whom will we go there in a month\\?)/gm"
    },
    {
      "rus": "Она приедет сюда со своей подругой через год",
      "eng": "She will come here with her friend in a year",
      "regEng": "/(?:(?:She|She’ll) will come here with her friend in a year)|(?:In a year (?:she|she’ll) will come here with her friend)/gm"
    },
    {
      "rus": "Она не приедет сюда со своей подругой через год",
      "eng": "She will not come here with her friend in a year",
      "regEng": "/(?:(?:She will not|She won’t|She’ll not) come here with her friend in a year)|(?:In a year (?:she will not|she won’t|she’ll not) come here with her friend)/gm"
    },
    {
      "rus": "Приедет ли она сюда со своей подругой через год?",
      "eng": "Will she come here with her friend in a year?"
    },
    {
      "rus": "С кем она приедет сюда через год?",
      "eng": "Who will she come here with in a year?",
      "regEng": "/(?:(?:Who|Whom) will she come here with in a year\\?)|(?:With whom will she come here in a year\\?)/gm"
    }
  ],
  [
    {
      "rus": "Он хороший доктор",
      "eng": "He is a good doctor",
      "regEng": "/(?:(?:He is|He’s) a good doctor)/gm"
    },
    {
      "rus": "Он не хороший доктор",
      "eng": "He is not a good doctor",
      "regEng": "/(?:(?:He is|He’s) not a good doctor)|(?:He isn’t a good doctor)/gm"
    },
    {
      "rus": "Он хороший доктор?",
      "eng": "Is he a good doctor?"
    },
    {
      "rus": "Кто он?",
      "eng": "Who is he?"
    },
    {
      "rus": "Вы замечательный учитель",
      "eng": "You are a great teacher",
      "regEng": "/(?:(?:You are|You’re) a great teacher)/gm"
    },
    {
      "rus": "Вы не замечательный учитель",
      "eng": "You are not a great teacher",
      "regEng": "/(?:(?:You are|You’re) not a great teacher)|(?:You aren’t a great teacher)/gm"
    },
    {
      "rus": "Вы замечательный учитель?",
      "eng": "Are you a great teacher?"
    },
    {
      "rus": "Кто вы?",
      "eng": "Who are you?"
    }
  ],
  [
    {
      "rus": "Я был здесь минуту назад",
      "eng": "I was here a minute ago",
      "regEng": "/(?:I was here a minute ago)|(?:A minute ago I was here)/gm"
    },
    {
      "rus": "Я не был здесь минуту назад",
      "eng": "I was not here a minute ago",
      "regEng": "/(?:I (?:was not|wasn’t) here a minute ago)|(?:A minute ago I (?:was not|wasn’t) here)/gm"
    },
    {
      "rus": "Был ли я здесь минуту назад?",
      "eng": "Was I here a minute ago?"
    },
    {
      "rus": "Где я был минуту назад?",
      "eng": "Where was I a minute ago?"
    },
    {
      "rus": "Они были там час назад",
      "eng": "They were there an hour ago",
      "regEng": "/(?:They were there an hour ago)|(?:An hour ago they were there)/gm"
    },
    {
      "rus": "Они не были там час назад",
      "eng": "They were not there an hour ago",
      "regEng": "/(?:They (?:were not|weren’t) there an hour ago)|(?:An hour ago they (?:were not|weren’t) there)/gm"
    },
    {
      "rus": "Были ли они там час назад?",
      "eng": "Were they there an hour ago?"
    },
    {
      "rus": "Где они были час назад?",
      "eng": "Where were they an hour ago?"
    }
  ],
  [
    {
      "rus": "Мы будем готовы на следующей неделе",
      "eng": "We will be ready next week",
      "regEng": "/(?:(?:We will|We’ll) be ready next week)|(?:Next week (?:we will|we’ll) be ready)/gm"
    },
    {
      "rus": "Мы не будем готовы на следующей неделе",
      "eng": "We will not be ready next week",
      "regEng": "/(?:(?:We will|We’ll) not be ready next week)|(?:We won’t be ready next week)|(?:Next week (?:we will|we’ll) not be ready)|(?:Next week we won’t be ready)/gm"
    },
    {
      "rus": "Будем ли мы готовы на следующей неделе?",
      "eng": "Will we be ready next week?"
    },
    {
      "rus": "Когда мы будем готовы?",
      "eng": "When will we be ready?"
    },
    {
      "rus": "Он будет очень успешным в следующем году",
      "eng": "He will be very successful next year",
      "regEng": "/(?:(?:He will|He’ll) be very successful next year)|(?:Next year (?:he will|he’ll) be very successful)/gm"
    },
    {
      "rus": "Он не будет очень успешным в следующем году",
      "eng": "He will not be very successful next year",
      "regEng": "/(?:(?:He will|He’ll) not be very successful next year)|(?:He won’t be very successful next year)|(?:Next year (?:he will|he’ll) not be very successful)|(?:Next year he won’t be very successful)/gm"
    },
    {
      "rus": "Будет ли он очень успешным в следующем году?",
      "eng": "Will he be very successful next year?"
    },
    {
      "rus": "Когда он будет очень успешным?",
      "eng": "When will he be very successful?"
    }
  ],
  [
    {
      "rus": "Мы получим письмо от наших родственников через неделю",
      "eng": "We will get a letter from our relatives in a week",
      "regEng": "/(?:(?:We will|We’ll) (?:get|receive) a letter from our relatives in a week)|(?:In a week (?:we will|we’ll) (?:get|receive) a letter from our relatives)/gm"
    },
    {
      "rus": "От кого мы получим письмо через неделю?",
      "eng": "Who will we get a letter from in a week?",
      "regEng": "/(?:Whom? will we (?:get|receive) a letter from in a week\\?)|(?:From whom will we (?:get|receive) a letter in a week\\?)/gm"
    },
    {
      "rus": "Получим ли мы письмо от наших родственников через неделю?",
      "eng": "Will we get a letter from our relatives in a week?",
      "regEng": "/(?:Will we (?:get|receive) a letter from our relatives in a week\\?)/gm"
    },
    {
      "rus": "Мы не получим письмо от наших родственников через неделю",
      "eng": "We will not get a letter from our relatives in a week",
      "regEng": "/(?:(?:We will|We’ll) not (?:get|receive) a letter from our relatives in a week)|(?:We won’t (?:get|receive) a letter from our relatives in a week)|(?:In a week (?:we will|we’ll) not (?:get|receive) a letter from our relatives)|(?:In a week we won’t (?:get|receive) a letter from our relatives)/gm"
    },
    {
      "rus": "Что ему нужно искать?",
      "eng": "What does he need to look for?",
      "regEng": "/(?:What does he need to (?:look|search) for\\?)/gm"
    },
    {
      "rus": "Ему нужно искать новую работу",
      "eng": "He needs to look for a new job",
      "regEng": "/(?:He needs to (?:look|search) for a new job)/gm"
    },
    {
      "rus": "Нужно ли ему искать новую работу?",
      "eng": "Does he need to look for a new job?",
      "regEng": "/(?:Does he need to (?:look|search) for a new job\\?)/gm"
    },
    {
      "rus": "Ему не нужно искать новую работу",
      "eng": "He does not need to look for a new job",
      "regEng": "/(?:He (?:does not|doesn’t) need to (?:look|search) for a new job)/gm"
    }
  ],
  [
    {
      "rus": "Я хороший человек",
      "eng": "I am a good person",
      "regEng": "/(?:(?:I am|I’m) a (?:good|nice) person)/gm"
    },
    {
      "rus": "Я не плохой человек",
      "eng": "I am not a bad person",
      "regEng": "/(?:(?:I am|I’m) not a bad person)/gm"
    },
    {
      "rus": "Хороший ли я человек?",
      "eng": "Am I a good person?",
      "regEng": "/(?:Am I a (?:good|nice) person\\?)/gm"
    },
    {
      "rus": "Кто я?",
      "eng": "Who am I?"
    },
    {
      "rus": "Вы опоздали в понедельник",
      "eng": "You were late on Monday",
      "regEng": "/(?:You were late on Monday)|(?:On Monday you were late)/gm"
    },
    {
      "rus": "Вы не опоздали в понедельник",
      "eng": "You were not late on Monday",
      "regEng": "/(?:You (?:were not|weren’t) late on Monday)|(?:On Monday You (?:were not|weren’t) late)/gm"
    },
    {
      "rus": "Опоздали ли вы в понедельник?",
      "eng": "Were you late on Monday?"
    },
    {
      "rus": "Когда вы опоздали?",
      "eng": "When were you late?"
    }
  ],
  [
    {
      "rus": "Она будет с ними в следующем месяце",
      "eng": "She will be with them next month",
      "regEng": "/(?:(?:She will|She’ll) be with them next month)|(?:Next month (?:she will|she’ll) be with them)/gm"
    },
    {
      "rus": "Она не будет с ними в следующем месяце",
      "eng": "She will not be with them next month",
      "regEng": "/(?:(?:She will|She’ll) not be with them next month)|(?:She won’t be with them next month)|(?:Next month (?:she will|she’ll) not be with them)|(?:Next month she won’t be with them)/gm"
    },
    {
      "rus": "Будет ли она с ними в следующем месяце?",
      "eng": "Will she be with them next month?"
    },
    {
      "rus": "С кем она будет в следующем месяце?",
      "eng": "Who will she be with next month?",
      "regEng": "/(?:Whom? will she be with next month\\?)|(?:With whom will she be next month\\?)/gm"
    },
    {
      "rus": "Он спешит",
      "eng": "He is in a hurry",
      "regEng": "/(?:(?:He is|He’s) in a hurry)/gm"
    },
    {
      "rus": "Он не спешит",
      "eng": "He is not in a hurry",
      "regEng": "/(?:(?:He is|He’s) not in a hurry)|(?:He isn’t in a hurry)/gm"
    },
    {
      "rus": "Спешит ли он?",
      "eng": "Is he in a hurry?"
    },
    {
      "rus": "Почему он спешит?",
      "eng": "Why is he in a hurry?"
    }
  ],
  [
    {
      "rus": "Они готовы начать через минуту",
      "eng": "They are ready to start in a minute",
      "regEng": "/(?:In a minute (?:they are ready to|they’re ready so) (?:start|begin)|(?:They are ready to|They’re ready so) (?:start|begin) in a minute)/gm"
    },
    {
      "rus": "Они не готовы начать через минуту",
      "eng": "They are not ready to start in a minute",
      "regEng": "/(?:In a minute (?:they are|they’re) not ready to (?:start|begin)|(?:They are|They’re) not ready to (?:start|begin) in a minute)/gm"
    },
    {
      "rus": "Готовы ли они начать через минуту?",
      "eng": "Are they ready to start in a minute?",
      "regEng": "/(?:Are they ready to (?:start|begin) in a minute\\?)/gm"
    },
    {
      "rus": "Что они готовы сделать через минуту?",
      "eng": "What are they ready to do in a minute?"
    },
    {
      "rus": "Ты будешь очень уставшим завтра",
      "eng": "You will be very tired tomorrow",
      "regEng": "/(?:You(?: will|’ll) be very tired tomorrow)|(?:Tomorrow you(?: will|’ll) be very tired)/gm"
    },
    {
      "rus": "Ты не будешь очень уставшим завтра",
      "eng": "You will not be very tired tomorrow",
      "regEng": "/(?:You(?:(?: will|’ll) not| won’t) be very tired tomorrow)|(?:Tomorrow you(?:(?: will|’ll) not| won’t) be very tired)/gm"
    },
    {
      "rus": "Будешь ли ты очень уставшим завтра?",
      "eng": "Will you be very tired tomorrow?"
    },
    {
      "rus": "Почему ты будешь очень уставшим завтра?",
      "eng": "Why will you be very tired tomorrow?"
    }
  ],
  [
    {
      "rus": "Видели ли вы своих друзей в прошлом месяце?",
      "eng": "Did you see your friends last month?"
    },
    {
      "rus": "Знаешь ли ты её имя?",
      "eng": "Do you know her name?"
    },
    {
      "rus": "Когда они принесут эти вещи сюда?",
      "eng": "When will they bring these things here?"
    },
    {
      "rus": "Я хочу, чтобы мы пошли в это место вместе в четверг",
      "eng": "I want us to go to this place together on Thursday",
      "regEng": "/(?:I want us to go to this place together on Thursday)|(?:On Thursday I want is to go to this place together)/gm"
    },
    {
      "rus": "У этого мужчины такой огромный нос",
      "eng": "This man has such a huge nose"
    },
    {
      "rus": "Он хочет, чтобы она поужинала с ним",
      "eng": "He wants her to have dinner with him"
    },
    {
      "rus": "С кем нам нужно поговорить?",
      "eng": "Who do we need to talk to?",
      "regEng": "/(?:Whom? do we need to (?:talk|speak) (?:to|with)\\?)|(?:(?:To|With) whom do we need to (?:talk|speak)\\?)/gm"
    }
  ],
  [
    {
      "rus": "У меня есть отличное решение",
      "eng": "I have an excellent solution",
      "regEng": ""
    },
    {
      "rus": "Хочет ли она пойти на эту вечеринку?",
      "eng": "Does she want to go to this party?",
      "regEng": ""
    },
    {
      "rus": "В понедельник мы посмотрели интересный фильм",
      "eng": "On Monday we watched an interesting film",
      "regEng": "/(?:On Monday we watched an interesting film)|(?:We watched an interesting film on Monday)/gm"
    },
    {
      "rus": "В прошлое воскресенье мы пообедали вместе",
      "eng": "Last Sunday we had lunch together",
      "regEng": "/(?:Last Sunday we had lunch together)|(?:We had lunch together last Sunday)/gm"
    },
    {
      "rus": "Что ты хочешь, чтобы я сделал?",
      "eng": "What do you want me to do?",
      "regEng": ""
    },
    {
      "rus": "Летом я обычно езжу на работу на велосипеде",
      "eng": "In summer I usually go to work by bicycle",
      "regEng": "/(?:In summer I usually go to work by bicycle)|(?:I usually go to work by bicycle in summer)/gm"
    },
    {
      "rus": "Поехали ли они на работу на общественном транспорте вчера?",
      "eng": "Did they go to work by public transport yesterday?",
      "regEng": ""
    },
    {
      "rus": "О чём она хочет поговорить?",
      "eng": "What does she want to talk about?",
      "regEng": "/(?:What does she want to talk about\\?)|(?:What does she want to speak about\\?)/gm"
    }
  ],
  [
    {
      "rus": "Я очень хочу пить",
      "eng": "I am very thirsty",
      "regEng": "/(?:(?:I am|I’m) very thirsty)/gm"
    },
    {
      "rus": "Я не очень хочу пить",
      "eng": "I am not very thirsty",
      "regEng": "/(?:(?:I am|I’m) not very thirsty)/gm"
    },
    {
      "rus": "Очень ли я хочу пить",
      "eng": "Am I very thirsty?",
      "regEng": ""
    },
    {
      "rus": "Почему я так хочу пить ?",
      "eng": "Why am I so thirsty?",
      "regEng": ""
    },
    {
      "rus": "Они очень сожалеют",
      "eng": "They are very sorry",
      "regEng": "/(?:(?:They are|They’re) very sorry)/gm"
    },
    {
      "rus": "Они не очень сожалеют",
      "eng": "They are not very sorry",
      "regEng": "/(?:(?:They are|They’re) not very sorry)|(?:They aren’t very sorry)/gm"
    },
    {
      "rus": "Очень ли они сожалеют?",
      "eng": "Are they very sorry?",
      "regEng": ""
    },
    {
      "rus": "Почему они так сожалеют?",
      "eng": "Why are they so sorry?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Эта женщина всегда готова помочь",
      "eng": "This woman is always ready to help",
      "regEng": ""
    },
    {
      "rus": "Эта женщина не всегда готова помочь.",
      "eng": "This woman is not always ready to help",
      "regEng": "/(?:This woman (?:is not|isn’t) always ready to help)/gm"
    },
    {
      "rus": "Готова ли эта женщина всегда помочь?",
      "eng": "Is this woman always ready to help?",
      "regEng": ""
    },
    {
      "rus": "Что эта женщина всегда готова сделать?",
      "eng": "What is this woman always ready to do?",
      "regEng": ""
    },
    {
      "rus": "Эти мужчины часто опаздывают",
      "eng": "These men are often late",
      "regEng": ""
    },
    {
      "rus": "Эти мужчины не часто опаздывают",
      "eng": "These men are not often late",
      "regEng": "/(?:These men (?:are not|aren’t) often late)/gm"
    },
    {
      "rus": "Опаздывают ли эти мужчины часто?",
      "eng": "Are these men often late?",
      "regEng": ""
    },
    {
      "rus": "Почему эти мужчины часто опаздывают?",
      "eng": "Why are these men often late?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Тот фильм был о любви",
      "eng": "That film was about love",
      "regEng": "/That (?:film|movie) was about love/gm"
    },
    {
      "rus": "Тот фильм не был о любви",
      "eng": "That film was not about love",
      "regEng": "/That (?:film|movie) (?:was not|wasn’t) about love/gm"
    },
    {
      "rus": "Был ли тот фильм о любви?",
      "eng": "Was that film about love?",
      "regEng": "/Was that (?:film|movie) about love\\?/gm"
    },
    {
      "rus": "О чём был тот фильм?",
      "eng": "What was that film about?",
      "regEng": "/What was that (?:film|movie) about\\?/gm"
    },
    {
      "rus": "Те женщины были из России",
      "eng": "Those women were from Russia",
      "regEng": ""
    },
    {
      "rus": "Те женщины не были из России",
      "eng": "Those women were not from Russia",
      "regEng": "/Those women (?:were not|weren’t) from Russia/gm"
    },
    {
      "rus": "Были ли те женщины из России?",
      "eng": "Were those women from Russia?",
      "regEng": ""
    },
    {
      "rus": "Откуда были те женщины?",
      "eng": "Where were those women from?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Этот мужчина всегда будет гордиться своей дочерью",
      "eng": "This man will always be proud of his daughter",
      "regEng": ""
    },
    {
      "rus": "Этот мужчина не всегда будет гордиться своей дочерью",
      "eng": "This man will not always be proud of his daughter",
      "regEng": "/This man (?:will not|won’t) always be proud of his daughter/gm"
    },
    {
      "rus": "Будет ли этот мужчина всегда гордиться своей дочерью?",
      "eng": "Will this man always be proud of his daughter?",
      "regEng": ""
    },
    {
      "rus": "Кем этот мужчина будет всегда гордиться?",
      "eng": "Who will this man always be proud of?",
      "regEng": ""
    },
    {
      "rus": "Эти люди будут часто беспокоиться о деньгах",
      "eng": "These people will often be worried about money",
      "regEng": "/These people will often (?:be worried|worry) about money/gm"
    },
    {
      "rus": "Эти люди будут не часто беспокоиться о деньгах",
      "eng": "These people will not often be worried about money",
      "regEng": "/These people (?:will not|won’t) often (?:be worried|worry) about money/gm"
    },
    {
      "rus": "Будут ли эти люди часто беспокоиться о деньгах?",
      "eng": "Will these people often be worried about money?",
      "regEng": "/Will these people often (?:be worried|worry) about money\\?/gm"
    },
    {
      "rus": "О чём эти люди будут часто беспокоиться?",
      "eng": "What will these people often be worried about?",
      "regEng": "/What will these people often (?:be worried|worry) about?/gm"
    }
  ],
  [
    {
      "rus": "Это машина твоего друга",
      "eng": "This is your friend`s car",
      "regEng": ""
    },
    {
      "rus": "Это не машина твоего друга",
      "eng": "This is not your friend`s car",
      "regEng": "/This (?:is not|isn’t) your friend’s car/gm"
    },
    {
      "rus": "Это машина твоего друга?",
      "eng": "Is this your friend`s car?",
      "regEng": ""
    },
    {
      "rus": "Чья это машина?",
      "eng": "Whose car is this?",
      "regEng": ""
    },
    {
      "rus": "Это туфли моей сестры",
      "eng": "These are my sister`s shoes",
      "regEng": ""
    },
    {
      "rus": "Это не туфли моей сестры",
      "eng": "These are not my sister`s shoes",
      "regEng": "/These (?:are not|aren’t) my sister’s shoes/gm"
    },
    {
      "rus": "Это туфли моей сестры?",
      "eng": "Are these my sister`s shoes?",
      "regEng": ""
    },
    {
      "rus": "Чьи это туфли?",
      "eng": "Whose shoes are these?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "То были документы её отца",
      "eng": "Those were her father`s documents",
      "regEng": "/Those were her (?:father`s|dad`s) documents/gm"
    },
    {
      "rus": "То не были документы её отца",
      "eng": "Those were not her father`s documents",
      "regEng": "/Those (?:were not|weren’t) her (?:father`s|dad`s) documents/gm"
    },
    {
      "rus": "То были документы её отца?",
      "eng": "Were those her father`s documents?",
      "regEng": "/Were those her (?:father`s|dad`s) documents\\?/gm"
    },
    {
      "rus": "Чьи документы то были?",
      "eng": "Whose documents were those?",
      "regEng": ""
    },
    {
      "rus": "То было платье его матери",
      "eng": "That was his mother`s dress",
      "regEng": "/That was his (?:mother`s|mom`s|mum`s) dress/gm"
    },
    {
      "rus": "То не было платье его матери",
      "eng": "That was not his mother`s dress",
      "regEng": "/That (?:was not|wasn’t) his (?:mother`s|mom`s|mum`s) dress/gm"
    },
    {
      "rus": "То было платье его матери?",
      "eng": "Was that his mother`s dress?",
      "regEng": "/Was that his (?:mother`s|mom`s|mum`s) dress\\?/gm"
    },
    {
      "rus": "Чьё платье то было?",
      "eng": "Whose dress was that?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Тебе очень холодно",
      "eng": "You are very cold",
      "regEng": "/(?:You are|You’re) very cold/gm"
    },
    {
      "rus": "Тебе не очень холодно",
      "eng": "You are not very cold",
      "regEng": "/(?:You are|You’re) not very cold/gm"
    },
    {
      "rus": "Очень ли тебе холодно?",
      "eng": "Are you very cold?",
      "regEng": ""
    },
    {
      "rus": "Почему тебе так холодно?",
      "eng": "Why are you so cold?",
      "regEng": ""
    },
    {
      "rus": "Мне очень жарко",
      "eng": "I am very hot",
      "regEng": "/(?:I am|I’m) very hot/gm"
    },
    {
      "rus": "Мне не очень жарко",
      "eng": "I am not very hot",
      "regEng": "/(?:I am|I’m) not very hot/gm"
    },
    {
      "rus": "Очень ли мне жарко?",
      "eng": "Am I very hot?",
      "regEng": ""
    },
    {
      "rus": "Почему мне так жарко?",
      "eng": "Why am I so hot?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Этот мужчина всегда рад видеть её",
      "eng": "This man is always glad to see her",
      "regEng": ""
    },
    {
      "rus": "Этот мужчина не всегда рад видеть её",
      "eng": "This man is not always glad to see her",
      "regEng": "/This man (?:is not|isn’t) always glad to see her/gm"
    },
    {
      "rus": "Рад ли этот мужчина всегда видеть её?",
      "eng": "Is this man always glad to see her?",
      "regEng": ""
    },
    {
      "rus": "Кого этот мужчина всегда рад видеть?",
      "eng": "Who is this man always glad to see?",
      "regEng": "/Whom? is this man always glad to see\\?/gm"
    },
    {
      "rus": "Эти люди обычно приходят вовремя",
      "eng": "These people are usually on time",
      "regEng": ""
    },
    {
      "rus": "Эти люди обычно не приходят вовремя",
      "eng": "These people are not usually on time",
      "regEng": "/These people (?:are not|aren’t) usually on time/gm"
    },
    {
      "rus": "Приходят ли эти люди обычно вовремя?",
      "eng": "Are these people usually on time?",
      "regEng": ""
    },
    {
      "rus": "Почему эти люди обычно приходят вовремя?",
      "eng": "Why are these people usually on time?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Тот человек интересовался музыкой",
      "eng": "That person was interested in music",
      "regEng": ""
    },
    {
      "rus": "Тот человек не интересовался музыкой",
      "eng": "That person was not interested in music",
      "regEng": "/That person (?:was not|wasn’t) interested in music/gm"
    },
    {
      "rus": "Интересовался ли тот человек музыкой?",
      "eng": "Was that person interested in music?",
      "regEng": ""
    },
    {
      "rus": "Чем интересовался тот человек?",
      "eng": "What was that person interested in?",
      "regEng": ""
    },
    {
      "rus": "Те дети боялись собак",
      "eng": "Those children were afraid of dogs",
      "regEng": "/Those (?:children|kids) were (?:afraid|scared) of dogs/gm"
    },
    {
      "rus": "Те дети не боялись собак",
      "eng": "Those children were not afraid of dogs",
      "regEng": "/Those (?:children|kids) (?:were not|weren’t) (?:afraid|scared) of dogs/gm"
    },
    {
      "rus": "Боялись ли те дети собак?",
      "eng": "Were those children afraid of dogs?",
      "regEng": "/Were those (?:children|kids) (?:afraid|scared) of dogs\\?/gm"
    },
    {
      "rus": "Чего боялись те дети?",
      "eng": "What were those children afraid of?",
      "regEng": "/What were those (?:children|kids) (?:afraid|scared) of?/gm"
    }
  ],
  [
    {
      "rus": "Мужчины всегда будут без ума от таких женщин",
      "eng": "Men will always be crazy about such women",
      "regEng": ""
    },
    {
      "rus": "Мужчины не всегда будут без ума от таких женщин",
      "eng": "Men will not always be crazy about such women",
      "regEng": "/Men (?:will not|won’t) always be crazy about such women/gm"
    },
    {
      "rus": "Будут ли мужчины всегда без ума от таких женщин?",
      "eng": "Will men always be crazy about such women?",
      "regEng": ""
    },
    {
      "rus": "От кого мужчины всегда будут без ума?",
      "eng": "Who will men always be crazy about?",
      "regEng": ""
    },
    {
      "rus": "Эти люди будут часто уставшими от работы",
      "eng": "These people will often be tired of work",
      "regEng": ""
    },
    {
      "rus": "Эти люди не будут часто уставшими от работы",
      "eng": "These people will not often be tired of work",
      "regEng": "/These people (?:will not|won’t) often be tired of work/gm"
    },
    {
      "rus": "Будут ли эти люди часто уставшими от работы?",
      "eng": "Will these people often be tired of work?",
      "regEng": ""
    },
    {
      "rus": "От чего эти люди будут часто уставшими?",
      "eng": "What will these people often be tired of?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Это сумка вашей тёти",
      "eng": "This is your aunt`s bag",
      "regEng": ""
    },
    {
      "rus": "Это сумка не вашей тёти",
      "eng": "This is not your aunt`s bag",
      "regEng": "/This (?:is not|isn’t) your aunt’s bag/gm"
    },
    {
      "rus": "Это сумка вашей тёти?",
      "eng": "Is this your aunt`s bag?",
      "regEng": ""
    },
    {
      "rus": "Чья это сумка?",
      "eng": "Whose bag is this?",
      "regEng": ""
    },
    {
      "rus": "Это одежда нашего брата",
      "eng": "These are our brother`s clothes",
      "regEng": ""
    },
    {
      "rus": "Это одежда не нашего брата",
      "eng": "These are not our brother`s clothes",
      "regEng": "/These (?:are not|aren’t) our brother`s clothes/gm"
    },
    {
      "rus": "Это одежда нашего брата?",
      "eng": "Are these our brother`s clothes?",
      "regEng": ""
    },
    {
      "rus": "Чья это одежда?",
      "eng": "Whose clothes are these?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "То были часы его дедушки",
      "eng": "That was his grandfather`s watch",
      "regEng": "/That was his (?:grandfather’s|grandpa’s) watch/gm"
    },
    {
      "rus": "То были часы не его дедушки",
      "eng": "That was not his grandfather`s watch",
      "regEng": "/That (?:was not|wasn’t) his (?:grandfather’s|grandpa’s) watch/gm"
    },
    {
      "rus": "То были часы его дедушки?",
      "eng": "Was that his grandfather`s watch?",
      "regEng": "/Was that his (?:grandfather’s|grandpa’s) watch\\?/gm"
    },
    {
      "rus": "Чьи то были часы?",
      "eng": "Whose watch was that?",
      "regEng": ""
    },
    {
      "rus": "То были книги моего дяди",
      "eng": "Those were my uncle`s books",
      "regEng": ""
    },
    {
      "rus": "То были книги не моего дяди",
      "eng": "Those were not my uncle`s books",
      "regEng": "/Those (?:were not|weren’t) my uncle’s books/gm"
    },
    {
      "rus": "То были книги моего дяди?",
      "eng": "Were those my uncle`s books?",
      "regEng": ""
    },
    {
      "rus": "Чьи книги то были?",
      "eng": "Whose books were those?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Моя сестра отличный доктор",
      "eng": "My sister is an excellent doctor",
      "regEng": ""
    },
    {
      "rus": "Тебе нравится играть в игры? Да, мне нравится играть в карты",
      "eng": "Do you like to play games? Yes, I like to play cards",
      "regEng": "/Do you like to (?:play|playing) games\\? Yes, I like to play cards/gm"
    },
    {
      "rus": "На прошлой неделе они поужинали вместе",
      "eng": "Last week they had dinner together",
      "regEng": "/(?:Last week they had dinner together)|(?:They had dinner together last week)/gm"
    },
    {
      "rus": "Когда вы открыли свой магазин? Мы открыли свой магазин месяц назад",
      "eng": "When did you open your shop? We opened our shop a month ago",
      "regEng": ""
    },
    {
      "rus": "Где живёт твоя подруга?",
      "eng": "Where does your friend live?",
      "regEng": ""
    },
    {
      "rus": "С кем вы хотите, чтобы я поговорил?",
      "eng": "Who do you want me to talk to?",
      "regEng": "/(?:Whom? do you want me to (?:talk|speak) (?:to|with)\\?)|(?:(?:To|With) whom do you want me to (?:talk|speak)\\?)/gm"
    },
    {
      "rus": "Когда её муж пришёл домой?",
      "eng": "When did her husband come home?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Мы всегда завтракаем рано",
      "eng": "We always have breakfast early",
      "regEng": ""
    },
    {
      "rus": "Что она хочет послушать? Я не знаю",
      "eng": "What does she want to listen to? I do not know",
      "regEng": "/What does she want to listen to\\? I (?:do not|don’t) know/gm"
    },
    {
      "rus": "Он встретил свою жену год назад",
      "eng": "He met his wife a year ago",
      "regEng": "/(?:He met his wife a year ago)|(?:A year ago he met his wife)/gm"
    },
    {
      "rus": "Почему тебе нужно пойти туда?",
      "eng": "Why do you need to go there?",
      "regEng": ""
    },
    {
      "rus": "Её брат такой успешный",
      "eng": "Her brother is so successful",
      "regEng": ""
    },
    {
      "rus": "Вчера мы поехали на работу на такси",
      "eng": "Yesterday we went to work by taxi",
      "regEng": "/(?:Yesterday we went to work by taxi)|(?:We went to work by taxi yesterday)/gm"
    },
    {
      "rus": "Что она пьёт каждое утро? Каждое утро она пьёт кофе",
      "eng": "What does she drink every morning? Every morning she drinks coffee",
      "regEng": "/What does she drink every morning\\? (?:Every morning she drinks coffee|She drinks coffee every morning)/gm"
    },
    {
      "rus": "Эти люди такие добрые и дружелюбные",
      "eng": "These people are so kind and friendly",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Она хочет, чтобы я помог её детям",
      "eng": "She wants me to help her children",
      "regEng": ""
    },
    {
      "rus": "Вчера ты пришел домой рано",
      "eng": "Yesterday you came home early",
      "regEng": "/(?:Yesterday you came home early)|(?:You came home early yesterday)/gm"
    },
    {
      "rus": "Эти женщины никогда не смотрят такие шоу",
      "eng": "These women never watch such shows",
      "regEng": ""
    },
    {
      "rus": "Что мы часто ищем здесь?",
      "eng": "What do we often look for here?",
      "regEng": "/What do we often (?:look|search) for here\\?/gm"
    },
    {
      "rus": "Я видел вашу дочь вчера",
      "eng": "I saw your daughter yesterday",
      "regEng": "/(?:I saw your daughter yesterday)|(?:Yesterday I saw your daughter)/gm"
    },
    {
      "rus": "Ему нравится посещать интересные места каждый год",
      "eng": "He likes to visit interesting places every year",
      "regEng": ""
    },
    {
      "rus": "Эти люди такие добрые и дружелюбные",
      "eng": "These people are so kind and friendly",
      "regEng": ""
    },
    {
      "rus": "Родителям нужно, чтобы их дети чистили свои зубы",
      "eng": "Parents need their children to brush their teeth",
      "regEng": ""
    },
    {
      "rus": "Когда они пообедали?",
      "eng": "When did they have lunch?",
      "regEng": ""
    },
    {
      "rus": "Нам нужно найти новую квартиру",
      "eng": "We need to find a new flat",
      "regEng": "/We need to find a new (?:flat|apartment)/gm"
    }
  ],
  [
    {
      "rus": "Вчера они поиграли в игры",
      "eng": "Yesterday they played games",
      "regEng": ""
    },
    {
      "rus": "Завтра он не позвонит своему другу",
      "eng": "Tomorrow he will not call his friend",
      "regEng": "/(?:Tomorrow he (?:will not|won’t) call his friend)|(?:He (?:will not|won’t) call his friend tomorrow)/gm"
    },
    {
      "rus": "Чтобы сделать это, тебе нужно быть сильным",
      "eng": "To do this you need to be strong",
      "regEng": "/(?:To do (?:this|it|that) you need to be strong)|(?:You need to be strong to do (?:this|it|that))/gm"
    },
    {
      "rus": "Поехали ли они домой на поезде месяц назад?",
      "eng": "Did they go home by train a month ago?",
      "regEng": ""
    },
    {
      "rus": "Она хочет иметь отличную работу",
      "eng": "She wants to have an excellent job",
      "regEng": ""
    },
    {
      "rus": "Завтра я увижу этого человека здесь",
      "eng": "Tomorrow I will see this person here",
      "regEng": "/(?:Tomorrow (?:I will|I’ll) see this person here)|(?:(?:I will|I’ll) see this person here tomorrow)/gm"
    },
    {
      "rus": "Мы съездили в это место в прошлом феврале",
      "eng": "We went to this place last February",
      "regEng": ""
    },
    {
      "rus": "Наш ребёнок никогда не ест гамбургеры",
      "eng": "Our child never eats hamburgers",
      "regEng": ""
    },
    {
      "rus": "Будем ли мы готовы на следующей неделе?",
      "eng": "Will we be ready next week?",
      "regEng": ""
    },
    {
      "rus": "Почему тебе так холодно?",
      "eng": "Why are you so cold?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Кто хочет услышать отличную историю?",
      "eng": "Who wants to hear an excellent story?",
      "regEng": ""
    },
    {
      "rus": "Я обычно прихожу сюда в понедельник, чтобы увидеть всех своих друзей",
      "eng": "I usually come here on Monday to see all my friends",
      "regEng": ""
    },
    {
      "rus": "Приходят ли эти люди обычно вовремя?",
      "eng": "Are these people usually on time?",
      "regEng": ""
    },
    {
      "rus": "Взяли ли вы мою машину вчера?",
      "eng": "Did you take my car yesterday?",
      "regEng": ""
    },
    {
      "rus": "У меня есть хороший вопрос",
      "eng": "I have a good question",
      "regEng": ""
    },
    {
      "rus": "У этого мужчины такой огромный нос",
      "eng": "This man has such a huge nose",
      "regEng": ""
    },
    {
      "rus": "Тренируется ли она перед работой?",
      "eng": "Does she exercise before work?",
      "regEng": ""
    },
    {
      "rus": "Тот мужчина обычно покупает дорогие костюмы",
      "eng": "That man usually buys expensive suits",
      "regEng": ""
    },
    {
      "rus": "Завтра я приду сюда",
      "eng": "Tomorrow I will come here",
      "regEng": "/(?:Tomorrow (?:I will|I’ll) come here)|(?:(?:I will|I’ll) come here tomorrow)/gm"
    },
    {
      "rus": "Вы никогда не говорите об этом",
      "eng": "You never talk about it",
      "regEng": "/You never (?:talk|speak) about (?:it|this|that)/gm"
    }
  ],
  [
    {
      "rus": "У тебя такие белые зубы!",
      "eng": "You have such white teeth!",
      "regEng": ""
    },
    {
      "rus": "Поехала ли она на работу на машине час назад?",
      "eng": "Did she go to work by car an hour ago?",
      "regEng": ""
    },
    {
      "rus": "Где они были час назад?",
      "eng": "Where were they an hour ago?",
      "regEng": ""
    },
    {
      "rus": "Чтобы быть здоровым, тебе нужно есть хорошую еду",
      "eng": "To be healthy you need to eat good food",
      "regEng": ""
    },
    {
      "rus": "Что вы принесёте ему завтра?",
      "eng": "What will you bring him tomorrow?",
      "regEng": ""
    },
    {
      "rus": "Они прочитали её важное сообщение вчера",
      "eng": "They read her important message yesterday",
      "regEng": "/(?:They read her important message yesterday)|(?:Yesterday they read her important message)/gm"
    },
    {
      "rus": "Они готовы начать через минуту",
      "eng": "They are ready to start in a minute",
      "regEng": "/(?:They are|They’re) ready to start in a minute/gm"
    },
    {
      "rus": "У этой семьи огромный дом",
      "eng": "This family has a huge house",
      "regEng": ""
    },
    {
      "rus": "Он не часто ужинает там в понедельник",
      "eng": "He does not often have dinner there on Monday",
      "regEng": "/He (?:does not|doesn’t) often have dinner there on Monday/gm"
    },
    {
      "rus": "О чём был тот фильм?",
      "eng": "What was that film about?",
      "regEng": "/What was that (?:film|movie) about\\?/gm"
    }
  ],
  [
    {
      "rus": "Они начали новый проект прошлой весной",
      "eng": "They started a new project last spring",
      "regEng": ""
    },
    {
      "rus": "Мы позавтракаем с вами через час",
      "eng": "We will have breakfast with you in an hour",
      "regEng": "/(?:We will|We’ll) have breakfast with you in an hour/gm"
    },
    {
      "rus": "Кто вы?",
      "eng": "Who are you?",
      "regEng": ""
    },
    {
      "rus": "Её дети всегда слушают её",
      "eng": "Her children always listen to her",
      "regEng": ""
    },
    {
      "rus": "Женщины хотят, чтобы мужчины любили их",
      "eng": "Women want men to love them",
      "regEng": ""
    },
    {
      "rus": "Что ты делаешь после работы?",
      "eng": "What do you do after work?",
      "regEng": ""
    },
    {
      "rus": "Чтобы быть сильным и здоровым, ему нужно тренироваться",
      "eng": "To be strong and healthy he needs to exercise",
      "regEng": "/(?:To be strong and healthy he needs to exercise)|(?:He needs to exercise to be strong and healthy)/gm"
    },
    {
      "rus": "С кем он поговорит через неделю?",
      "eng": "Who will he talk to in a week?",
      "regEng": "/Who will he (?:talk|speak) (?:to|with) in a week\\?/gm"
    },
    {
      "rus": "Тот человек интересовался музыкой",
      "eng": "That person was interested in music",
      "regEng": ""
    },
    {
      "rus": "Этим женщинам нужно, чтобы вы послушали их",
      "eng": "These women need you to listen to them",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "У кого есть сложный вопрос?",
      "eng": "Who has a difficult question?",
      "regEng": ""
    },
    {
      "rus": "Она не всегда слушает эти песни в среду",
      "eng": "She does not always listen to these songs on Wednesday",
      "regEng": "/She (?:does not|doesn’t) always listen to these songs on Wednesday/gm"
    },
    {
      "rus": "О чём эти люди будут часто беспокоиться?",
      "eng": "What will these people often be worried about?",
      "regEng": ""
    },
    {
      "rus": "Завтра у нас будет отличная вечеринка",
      "eng": "Tomorrow we will have an excellent party",
      "regEng": "/(?:Tomorrow (?:we will|we’ll) have an excellent party)|(?:(?:We will|We’ll) have an excellent party tomorrow)/gm"
    },
    {
      "rus": "Ужинают ли они всегда рано в воскресенье?",
      "eng": "Do they always have dinner early on Sunday?",
      "regEng": ""
    },
    {
      "rus": "Завтракает ли она часто поздно в субботу?",
      "eng": "Does she often have breakfast late on Saturday?",
      "regEng": ""
    },
    {
      "rus": "Эти люди часто читают газеты и журналы",
      "eng": "These people often read newspapers and magazines",
      "regEng": ""
    },
    {
      "rus": "Вчера я написал вам сообщение",
      "eng": "Yesterday I wrote you a message",
      "regEng": "/(?:Yesterday I wrote you a message)|(?:I wrote you a message yesterday)/gm"
    },
    {
      "rus": "Когда ты пойдешь в кровать завтра?",
      "eng": "When will you go to bed tomorrow?",
      "regEng": "/When will you go to (?:bed|sleep) tomorrow?/gm"
    },
    {
      "rus": "Мы принесём тебе эти документы в следующий вторник",
      "eng": "We will bring you these documents next Tuesday",
      "regEng": "/(?:We will|We’ll) bring you these documents next Tuesday/gm"
    }
  ],
  [
    {
      "rus": "Кто помнит ту красивую девушку?",
      "eng": "Who remembers that beautiful girl?",
      "regEng": ""
    },
    {
      "rus": "Кого этот мужчина всегда рад видеть?",
      "eng": "Who is this man always glad to see?",
      "regEng": ""
    },
    {
      "rus": "Ей нравится шоколад?",
      "eng": "Does she like chocolate?",
      "regEng": ""
    },
    {
      "rus": "Эти мужчины часто опаздывают",
      "eng": "These men are often late",
      "regEng": ""
    },
    {
      "rus": "Я не был здесь минуту назад",
      "eng": "I was not here a minute ago",
      "regEng": "/I (?:was not|wasn’t) here a minute ago/gm"
    },
    {
      "rus": "Он хороший доктор",
      "eng": "He is a good doctor",
      "regEng": "/(?:He is|He’s) a good doctor/gm"
    },
    {
      "rus": "Чего он всегда ждёт?",
      "eng": "What does he always wait for?",
      "regEng": ""
    },
    {
      "rus": "В прошлый понедельник я поехал на работу на такси",
      "eng": "Last Monday I went to work by taxi",
      "regEng": ""
    },
    {
      "rus": "Ей нужно, чтобы я нашёл новую работу",
      "eng": "She needs me to find a new job",
      "regEng": ""
    },
    {
      "rus": "О чём мы подумаем через неделю?",
      "eng": "What will we think about in a week?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "С кем он обычно ходит туда?",
      "eng": "Who does he usually go there with?",
      "regEng": ""
    },
    {
      "rus": "Я очень хочу пить (испытываю жажду)",
      "eng": "I am very thirsty",
      "regEng": "/(?:(?:I am|I’m) very thirsty)/gm"
    },
    {
      "rus": "Она не поедет туда со своей сестрой через месяц",
      "eng": "She will not go there with her sister in a month",
      "regEng": "/(?:She (?:will not|won’t) go there with her sister in a month)/gm"
    },
    {
      "rus": "У кого есть зелёная ручка?",
      "eng": "Who has a green pen?",
      "regEng": ""
    },
    {
      "rus": "Ваши дети хотят, чтобы вы поиграли с ними",
      "eng": "Your children want you to play with them",
      "regEng": ""
    },
    {
      "rus": "Чья это сумка? Это сумка моей сестры",
      "eng": "Whose bag is this? This is my sister`s bag",
      "regEng": ""
    },
    {
      "rus": "Это друзья их брата? Нет, это не друзья их брата",
      "eng": "Are these their brother`s friends? No, these are not their brother`s friends",
      "regEng": "/(?:Are these their brother’s friends\\? No, these (?:are not|aren’t) their brother’s friends)/gm"
    },
    {
      "rus": "Чья это одежда? Это одежда её матери",
      "eng": "Whose clothes are these? These are her mother`s clothes",
      "regEng": "/(?:Whose clothes are these\\? These are her (?:mother’s|mom’s|mum’s) clothes)/gm"
    },
    {
      "rus": "То были часы твоего отца? Нет, то были часы не моего отца",
      "eng": "Was that your father`s watch? No, that was not my father`s watch",
      "regEng": "/(?:Was that your (?:father’s|dad’s|daddy’s) watch\\? No, that (?:was not|wasn’t) my father’s watch)/gm"
    }
  ],
  [
    {
      "rus": "Чей это дом? Это дом моего соседа",
      "eng": "Whose house is this? This is my neighbour`s house",
      "regEng": "/(?:Whose house is this\\? This is my neighbou?r’s house)/gm"
    },
    {
      "rus": "То были документы его коллеги? Нет, то были документы не его коллеги",
      "eng": "Were those his colleague`s documents? No, those were not his colleague`s documents",
      "regEng": "/(?:Were those his colleague’s documents\\? No, those (?:were not|weren’t) his colleague’s documents)/gm"
    },
    {
      "rus": "Чьи это туфли? Это туфли нашей бабушки",
      "eng": "Whose shoes are these? These are our grandmother`s shoes",
      "regEng": "/(?:Whose shoes are these\\? These are our (?:grandmother\\’s|granny\\’s) (?:shoes|boots))/gm"
    },
    {
      "rus": "Это ручка твоей подруги? Нет, это ручка не моей подруги",
      "eng": "Is this your friend`s pen? No, this is not my friend`s pen",
      "regEng": "/(?:Is this your friend’s pen\\? No, this (?:is not|isn’t) my friend’s pen)/gm"
    },
    {
      "rus": "Это моё пальто. Это пальто моё",
      "eng": "This is my coat. This coat is mine",
      "regEng": ""
    },
    {
      "rus": "Это твои брюки? Эти брюки твои?",
      "eng": "Are these your trousers? Are these trousers yours?",
      "regEng": "/(?:Are these your (?:trousers|pants)\\? Are these (?:trousers|pants) yours\\?)/gm"
    },
    {
      "rus": "Это наши новые рубашки. Эти новые рубашки наши",
      "eng": "These are our new shirts. These new shirts are ours",
      "regEng": ""
    },
    {
      "rus": "То было моё золотое кольцо? То золотое кольцо было моё?",
      "eng": "Was that my golden ring? Was that golden ring mine?",
      "regEng": ""
    },
    {
      "rus": "Это наша одежда. Эта одежда наша",
      "eng": "These are our clothes. These clothes are ours",
      "regEng": ""
    },
    {
      "rus": "То были их серебряные серёжки? Те серебряные серёжки были их?",
      "eng": "Were those their silver earrings? Were those silver earrings theirs?",
      "regEng": ""
    },
    {
      "rus": "Это его старые часы. Эти старые часы его",
      "eng": "This is his old watch. This old watch is his",
      "regEng": ""
    },
    {
      "rus": "Это её юбка? Эта юбка её?",
      "eng": "Is this her skirt? Is this skirt hers?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Чьи это платья? Они твои",
      "eng": "Whose dresses are these? They are yours",
      "regEng": "/(?:Whose dresses are these\\? (?:They are|They’re) yours)/gm"
    },
    {
      "rus": "То твои книги? Нет, мои здесь",
      "eng": "Are those your books? No, mine are here",
      "regEng": ""
    },
    {
      "rus": "Эти карандаши её, не твои",
      "eng": "These pencils are hers, not yours",
      "regEng": "/(?:These pencils are hers,(?:(?:(?: they are| they’re)? not)|(?: these (?:are not|aren’t))) yours)/gm"
    },
    {
      "rus": "Это их дом? Нет, их там",
      "eng": "Is this their house? No, theirs is there",
      "regEng": ""
    },
    {
      "rus": "Чья это сумка? Она моя",
      "eng": "Whose bag is this? It is mine",
      "regEng": "/(?:Whose bag is this\\? (?:It is|It’s) mine)/gm"
    },
    {
      "rus": "Эта еда ваша, не наша",
      "eng": "This food is yours, not ours",
      "regEng": "/(?:This food is yours,(?: it is| it’s)? not ours)/gm"
    },
    {
      "rus": "Чьи то серёжки? Они её",
      "eng": "Whose earrings are those? They are hers",
      "regEng": "/(?:Whose earrings are those\\? (?:They(?: are|’re) hers|These are hers))/gm"
    },
    {
      "rus": "Эта одежда их, не наша",
      "eng": "These clothes are theirs, not ours",
      "regEng": "/(?:These clothes are theirs,(?: not| (?:they(?: are|’re)? not|these (?:are not|aren’t))) ours)/gm"
    }
  ],
  [
    {
      "rus": "Мои шутки смешнее, чем её",
      "eng": "My jokes are funnier than hers",
      "regEng": ""
    },
    {
      "rus": "Их дом больше, чем наш",
      "eng": "Their house is bigger than ours",
      "regEng": "/(?:Their house is (?:bigger|larger) than ours)/gm"
    },
    {
      "rus": "Результаты моего брата лучше, чем мои",
      "eng": "My brother`s results are better than mine",
      "regEng": ""
    },
    {
      "rus": "Его машина более удобная, чем ваша",
      "eng": "His car is more comfortable than yours",
      "regEng": ""
    },
    {
      "rus": "Ваша ситуация хуже, чем их",
      "eng": "Your situation is worse than theirs",
      "regEng": ""
    },
    {
      "rus": "Наши сумки тяжелее, чем его",
      "eng": "Our bags are heavier than his",
      "regEng": ""
    },
    {
      "rus": "Волосы моей сестры темнее, чем мои",
      "eng": "My sister`s hair is darker than mine",
      "regEng": ""
    },
    {
      "rus": "Её тело тоньше, чем твоё",
      "eng": "Her body is thinner than yours",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Ваша кожа светлее, чем моя",
      "eng": "Your skin is lighter than mine",
      "regEng": ""
    },
    {
      "rus": "Мои руки сильнее, чем его",
      "eng": "My arms are stronger than his",
      "regEng": ""
    },
    {
      "rus": "Их еда жирнее, чем наша",
      "eng": "Their food is fatter than ours",
      "regEng": ""
    },
    {
      "rus": "Лицо её матери красивее, чем её",
      "eng": "Her mother`s face is more beautiful than hers",
      "regEng": "/(?:Her (?:mother’s|mom’s|mum’s) face is (?:more beautiful|prettier) than hers)/gm"
    },
    {
      "rus": "Ваш вопрос лучше, чем наш",
      "eng": "Your question is better than ours",
      "regEng": ""
    },
    {
      "rus": "Его сообщения более важные, чем их",
      "eng": "His messages are more important than theirs",
      "regEng": ""
    },
    {
      "rus": "Мои руки горячее, чем твои",
      "eng": "My hands are hotter than yours",
      "regEng": ""
    },
    {
      "rus": "Их бутерброды вкуснее, чем мои",
      "eng": "Their sandwiches are tastier than mine",
      "regEng": "/(?:Their sandwiches are (?:tastier|more delicious) than mine)/gm"
    }
  ],
  [
    {
      "rus": "Чьи это малыши? Это малыши моего соседа",
      "eng": "Whose babies are these? These are my neighbour`s babies",
      "regEng": "/(?:Whose babies are these\\? These are my neighbou?r’s babies)/gm"
    },
    {
      "rus": "То была сумка вашей дочери? Нет, то не была сумка нашей дочери",
      "eng": "Was that your daughter`s bag? No, that was not our daughter`s bag",
      "regEng": "/(?:Was that your daughter`s bag\\? No, that was not our daughter`s bag)/gm"
    },
    {
      "rus": "Чей то родственник? То родственник его жены",
      "eng": "Whose relative is that? That is his wife`s relative",
      "regEng": ""
    },
    {
      "rus": "То была одежда её мужа? Нет, то не была одежда её мужа",
      "eng": "Were those her husband`s clothes? No, those were not her husband`s clothes",
      "regEng": "/(?:Were those her husband’s clothes\\? No, those were not her husband’s clothes)/gm"
    },
    {
      "rus": "Чьи это коты? Это коты нашей бабушки",
      "eng": "Whose cats are these? These are our grandmother`s cats",
      "regEng": ""
    },
    {
      "rus": "Это часы их дедушки? Нет, это часы не их дедушки",
      "eng": "Is this their grandfather`s watch? No, this is not their grandfather`s watch",
      "regEng": "/(?:Is this their grandfather’s watch\\? No, this is not their grandfather’s watch)/gm"
    },
    {
      "rus": "Чей то был магазин? То был магазин моей семьи",
      "eng": "Whose shop was that? That was my family`s shop",
      "regEng": "/(?:Whose shop was that\\? That was my family’s shop)/gm"
    },
    {
      "rus": "То туфли её друга? Нет, то туфли не её друга",
      "eng": "Are those her friend`s shoes? No, those are not her friend`s shoes",
      "regEng": "/(?:Are those her friend’s shoes\\? No, those are not her friend’s shoes)/gm"
    }
  ],
  [
    {
      "rus": "Это её серебряное кольцо. Это серебряное кольцо её",
      "eng": "This is her silver ring. This silver ring is hers",
      "regEng": ""
    },
    {
      "rus": "То были ваши деньги. Те деньги были ваши",
      "eng": "That was your money. That money was yours",
      "regEng": ""
    },
    {
      "rus": "Это мои золотые серёжки. Эти золотые серёжки мои",
      "eng": "These are my golden earrings. These golden earrings are mine",
      "regEng": ""
    },
    {
      "rus": "Это его бутерброд. Этот бутерброд его",
      "eng": "This is his sandwich. This sandwich is his",
      "regEng": ""
    },
    {
      "rus": "То их новая одежда. Та новая одежда их",
      "eng": "Those are their new clothes. Those new clothes are theirs",
      "regEng": ""
    },
    {
      "rus": "Это наши жёлтые платья. Эти жёлтые платья наши",
      "eng": "These are our yellow dresses. These yellow dresses are ours",
      "regEng": ""
    },
    {
      "rus": "То были мои старые ботинки. Те старые ботинки были мои",
      "eng": "Those were my old shoes. Those old shoes were mine",
      "regEng": "/(?:Those were my old (?:shoes|boots)\\. Those old (?:shoes|boots) were mine)/gm"
    },
    {
      "rus": "То её синяя машина. Та синяя машина её",
      "eng": "That is her blue car. That blue car is hers",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Чей это телефон? Он мой",
      "eng": "Whose phone is this? It is mine",
      "regEng": "/(?:Whose (?:phone|telephone) is this\\? It(?: is|’s) mine)/gm"
    },
    {
      "rus": "Те сумки их, не наши",
      "eng": "Those bags are theirs, not ours",
      "regEng": ""
    },
    {
      "rus": "То её одежда? Нет, её здесь",
      "eng": "Are those her clothes? No, hers are here",
      "regEng": "/(?:Are those (?:her clothes|clothes hers)\\? No, hers are here)/gm"
    },
    {
      "rus": "Чьи это рубашки? Они ваши",
      "eng": "Whose shirts are these? They are yours",
      "regEng": "/(?:Whose shirts are these\\? (?:They are|They’re) yours)/gm"
    },
    {
      "rus": "Это его машина? Нет, его чёрная",
      "eng": "Is this his car? No, his is black",
      "regEng": "/(?:Is this (?:his car|car his)\\? No, his is black)/gm"
    },
    {
      "rus": "Чья это чашка? Она моя",
      "eng": "Whose cup is this? It is mine",
      "regEng": "/(?:Whose cup is this\\? It(?: is|’s) mine)/gm"
    },
    {
      "rus": "Этот зелёный зонтик наш, не их",
      "eng": "This green umbrella is ours, not theirs",
      "regEng": ""
    },
    {
      "rus": "Это её дом? Нет, её там",
      "eng": "Is this her house? No, hers is there",
      "regEng": "/(?:Is this (?:her house|house hers)\\? No, hers is there)/gm"
    }
  ],
  [
    {
      "rus": "Её лицо грустнее, чем моё",
      "eng": "Her face is sadder than mine",
      "regEng": ""
    },
    {
      "rus": "Наша одежда более дорогая, чем их",
      "eng": "Our clothes are more expensive than theirs",
      "regEng": ""
    },
    {
      "rus": "Их работа хуже, чем ваша",
      "eng": "Their job is worse than yours",
      "regEng": ""
    },
    {
      "rus": "Ваши истории интереснее наших",
      "eng": "Your stories are more interesting than ours",
      "regEng": ""
    },
    {
      "rus": "Его волосы короче, чем её",
      "eng": "His hair is shorter than hers",
      "regEng": ""
    },
    {
      "rus": "Твои руки длиннее моих",
      "eng": "Your arms are longer than mine",
      "regEng": ""
    },
    {
      "rus": "Моя идея лучше, чем его",
      "eng": "My idea is better than his",
      "regEng": ""
    },
    {
      "rus": "Её руки грязнее, чем твои",
      "eng": "Her hands are dirtier than yours",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Мой ответ лучше, чем их",
      "eng": "My answer is better than theirs",
      "regEng": "/(?:My (?:answer|reply) is better than theirs)/gm"
    },
    {
      "rus": "Наши ящики больше ваших",
      "eng": "Our boxes are bigger than yours",
      "regEng": "/(?:Our boxes are (?:bigger|larger) than yours)/gm"
    },
    {
      "rus": "Его тело более здоровое, чем её",
      "eng": "His body is healthier than hers",
      "regEng": ""
    },
    {
      "rus": "Их родственники более дружелюбные, чем мои",
      "eng": "Their relatives are friendlier than mine",
      "regEng": ""
    },
    {
      "rus": "Мой голос красивее, чем его",
      "eng": "My voice is more beautiful than his",
      "regEng": ""
    },
    {
      "rus": "Их навыки хуже, чем наши",
      "eng": "Their skills are worse than ours",
      "regEng": ""
    },
    {
      "rus": "Наша жизнь более счастливая, чем их",
      "eng": "Our life is happier than theirs",
      "regEng": ""
    },
    {
      "rus": "Твой лоб горячее, чем мой",
      "eng": "Your forehead is hotter than mine",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Я всегда хожу на работу пешком. Мне нравится свежий воздух",
      "eng": "I always go to work on foot. I like fresh air",
      "regEng": ""
    },
    {
      "rus": "Ты голоден? Нет, но я очень хочу пить",
      "eng": "Are you hungry? No, but I am very thirsty",
      "regEng": "/(?:Are you hungry\\? No, but (?:I am|I’m) very thirsty)/gm"
    },
    {
      "rus": "Мы не поедем в эту страну через месяц, мы поедем туда в следующем году",
      "eng": "We will not go to this country in a month, we will go there next year",
      "regEng": "/(?:We (?:will not|won’t) go to this country in a month, (?:we will|we’ll) go there next year)/gm"
    },
    {
      "rus": "О чём эта книга? Она о разных приключениях",
      "eng": "What is this book about? It is about different adventures",
      "regEng": "/(?:What is this book about\\? (?:It is|It’s) about different adventures)/gm"
    },
    {
      "rus": "Я видел твою сестру час назад. Она спешила",
      "eng": "I saw your sister an hour ago. She was in a hurry",
      "regEng": ""
    },
    {
      "rus": "Когда она поговорила с теми людьми? Она поговорила с ними в среду",
      "eng": "When did she talk to those people? She talked to them on Wednesday",
      "regEng": "/(?:When did she (?:talk|speak) (?:to|with) those people\\? She (?:talked|spoke) (?:to|with) them on Wednesday)/gm"
    },
    {
      "rus": "Их сын обычно ездит в школу на автобусе или на трамвае",
      "eng": "Their son usually goes to school by bus or by tram",
      "regEng": "/(?:Their son usually goes to school by bus or (?:by)? tram)/gm"
    },
    {
      "rus": "Она без ума от своего нового парня",
      "eng": "She is crazy about her new boyfriend",
      "regEng": "/(?:(?:She is|She’s) crazy about her new boyfriend)/gm"
    }
  ],
  [
    {
      "rus": "Чем интересуется ваш муж? Он интересуется литературой и музыкой",
      "eng": "What is your husband interested in? He is interested in literature and music",
      "regEng": "/(?:What is your husband interested in\\? (?:He is|He’s) interested in literature and music)/gm"
    },
    {
      "rus": "Вашему малышу холодно? Нет, ему жарко",
      "eng": "Is your baby cold? No, he is hot",
      "regEng": "/(?:Is your baby cold\\? No, (?:he is|he’s) hot)/gm"
    },
    {
      "rus": "Он хочет, чтобы мы познакомились с его новой девушкой",
      "eng": "He wants us to meet his new girlfriend",
      "regEng": ""
    },
    {
      "rus": "Кто готов помочь нам сегодня?",
      "eng": "Who is ready to help us today?",
      "regEng": ""
    },
    {
      "rus": "Почему ты всё время опаздываешь? Я не знаю",
      "eng": "Why are you late all the time? I do not know",
      "regEng": "/(?:Why are you late all the time\\? I (?:do not|don’t) know)/gm"
    },
    {
      "rus": "Кого вы хотите, чтобы я слушал?",
      "eng": "Who do you want me to listen to?",
      "regEng": ""
    },
    {
      "rus": "Он такой серьёзный человек. Он всегда приходит вовремя",
      "eng": "He is such a serious person. He is always on time",
      "regEng": "/(?:(?:He is|He’s) such a serious person. (?:He is|He’s) always on time)/gm"
    }
  ],
  [
    {
      "rus": "Квартира моих друзей больше, чем моя",
      "eng": "My friends` flat is bigger than mine",
      "regEng": "/(?:My friends` (?:flat|apartment) is (?:bigger|larger) than mine)/gm"
    },
    {
      "rus": "Чьи это письма? Они его",
      "eng": "Whose letters are these? They are his",
      "regEng": "/(?:Whose letters are these\\? (?:They are|They’re) his)/gm"
    },
    {
      "rus": "Это одежда наших детей, не ваша",
      "eng": "These are our children`s clothes, not yours",
      "regEng": ""
    },
    {
      "rus": "История наших родственников интереснее, чем её",
      "eng": "Our relatives` story is more interesting than hers",
      "regEng": ""
    },
    {
      "rus": "Чьи это деньги? Они их",
      "eng": "Whose money is this? It is theirs",
      "regEng": "/(?:Whose money is this\\? (?:It is|It’s) theirs)/gm"
    },
    {
      "rus": "Идеи тех мужчин лучше, чем наши",
      "eng": "Those men`s ideas are better than ours",
      "regEng": ""
    },
    {
      "rus": "Её брови тоньше ваших",
      "eng": "Her eyebrows are thinner than yours",
      "regEng": ""
    },
    {
      "rus": "Сумки моих родителей тяжелее, чем мои",
      "eng": "My parents` bags are heavier than mine",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Вы более привлекательны, чем она",
      "eng": "You are more attractive than she is",
      "regEng": "/(?:(?:You are|You’re) more attractive than (?:she(?: is)?|her))/gm"
    },
    {
      "rus": "Я счастливее, чем вы",
      "eng": "I am happier than you are",
      "regEng": "/(?:(?:I am|I’m) happier than you(?: are)?)/gm"
    },
    {
      "rus": "Он выше меня",
      "eng": "He is taller than I am",
      "regEng": "/(?:(?:He is|He’s) taller than (?:I(?: am)?|me))/gm"
    },
    {
      "rus": "Они более активные, чем мы",
      "eng": "They are more active than we are",
      "regEng": "/(?:(?:They are|They’re) more active than (?:we(?: are)?|us))/gm"
    },
    {
      "rus": "Я более талантливый, чем она",
      "eng": "I am more talented than she is",
      "regEng": "/(?:(?:I am|I’m) more talented than (?:she(?: is)?|her))/gm"
    },
    {
      "rus": "Он смелее, чем я",
      "eng": "He is braver than I am",
      "regEng": "/(?:(?:He is|He’s) braver than (?:I(?: am)?|me))/gm"
    },
    {
      "rus": "Ты более смешная, чем они",
      "eng": "You are funnier than they are",
      "regEng": "/(?:(?:You are|You’re) funnier than (?:they(?: are)?|them))/gm"
    },
    {
      "rus": "Ты более красивый, чем он",
      "eng": "You are more handsome than he is",
      "regEng": "/(?:(?:You are|You’re) more handsome than (?:he(?: is)?|him))/gm"
    }
  ],
  [
    {
      "rus": "Твои ресницы длиннее моих",
      "eng": "Your eyelashes are longer than mine",
      "regEng": ""
    },
    {
      "rus": "Он слабее, чем ты",
      "eng": "He is weaker than you are",
      "regEng": "/(?:(?:He is|He’s) weaker than you(?: are)?)/gm"
    },
    {
      "rus": "Они более уставшие, чем я",
      "eng": "They are more tired than I am",
      "regEng": "/(?:(?:They are|They’re) more tired than (?:I(?: am)?|me))/gm"
    },
    {
      "rus": "Чья то машина? Она наша",
      "eng": "Whose car is that? It is ours",
      "regEng": "/(?:Whose car is that\\? (?:It is|It’s) ours)/gm"
    },
    {
      "rus": "Мы более успешны, чем они",
      "eng": "We are more successful than they are",
      "regEng": "/(?:(?:We are|We’re) more successful than (?:they(?: are)?|them))/gm"
    },
    {
      "rus": "Это её волосы? Нет, её светлее",
      "eng": "Is this her hair? No, hers is lighter",
      "regEng": ""
    },
    {
      "rus": "Его еда вкуснее, чем моя",
      "eng": "His food is tastier than mine",
      "regEng": "/(?:His food is (?:tastier|more delicious) than mine)/gm"
    },
    {
      "rus": "Я спокойнее, чем она",
      "eng": "I am calmer than she is",
      "regEng": "/(?:(?:I am|I’m) calmer than (?:she(?: is)?|her))/gm"
    }
  ],
  [
    {
      "rus": "На столе стоит чашка",
      "eng": "There is a cup on the table",
      "regEng": "/(?:There(?:’s| is) a cup on the table)/gm"
    },
    {
      "rus": "Стоит ли на столе чашка?",
      "eng": "Is there a cup on the table?",
      "regEng": ""
    },
    {
      "rus": "Под кроватью были ящики",
      "eng": "There were boxes under the bed",
      "regEng": ""
    },
    {
      "rus": "Были ли ящики под кроватью?",
      "eng": "Were there boxes under the bed?",
      "regEng": ""
    },
    {
      "rus": "В ящике лежат игрушки",
      "eng": "There are toys in the box",
      "regEng": ""
    },
    {
      "rus": "Лежат ли в ящике игрушки?",
      "eng": "Are there toys in the box?",
      "regEng": ""
    },
    {
      "rus": "На кровати лежала подушка",
      "eng": "There was a pillow on the bed",
      "regEng": ""
    },
    {
      "rus": "Лежала ли на кровати подушка?",
      "eng": "Was there a pillow on the bed?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "В замке будет ключ",
      "eng": "There will be a key in the lock",
      "regEng": "/(?:There(?:’ll| will) be a key in the lock)/gm"
    },
    {
      "rus": "Будет ли в замке ключ?",
      "eng": "Will there be a key in the lock?",
      "regEng": ""
    },
    {
      "rus": "В сумке лежат бутылки",
      "eng": "There are bottles in the bag",
      "regEng": ""
    },
    {
      "rus": "Лежат ли в сумке бутылки?",
      "eng": "Are there bottles in the bag?",
      "regEng": ""
    },
    {
      "rus": "В комнате будут люди",
      "eng": "There will be people in the room",
      "regEng": "/(?:There(?:’ll| will) be people in the room)/gm"
    },
    {
      "rus": "Будут ли в комнате люди?",
      "eng": "Will there be people in the room?",
      "regEng": ""
    },
    {
      "rus": "На потолке висела лампа",
      "eng": "There was a lamp on the ceiling",
      "regEng": ""
    },
    {
      "rus": "Висела ли лампа на потолке?",
      "eng": "Was there a lamp on the ceiling?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "На столе лежали книги",
      "eng": "There were books on the table",
      "regEng": ""
    },
    {
      "rus": "Лежали ли книги на столе?",
      "eng": "Were there books on the table?",
      "regEng": ""
    },
    {
      "rus": "В комнате будет кресло",
      "eng": "There will be an armchair in the room",
      "regEng": "/(?:There(?:’ll| will) be an armchair in the room)/gm"
    },
    {
      "rus": "Будет ли в комнате кресло?",
      "eng": "Will there be an armchair in the room",
      "regEng": ""
    },
    {
      "rus": "На полу лежит ковёр",
      "eng": "There is a carpet on the floor",
      "regEng": "/(?:There(?:’s| is) a carpet on the floor)/gm"
    },
    {
      "rus": "Лежит ли на полу ковёр?",
      "eng": "Is there a carpet on the floor?",
      "regEng": ""
    },
    {
      "rus": "На стенах будут картины",
      "eng": "There will be pictures on the walls",
      "regEng": "/(?:There(?:’ll| will) be pictures on the walls)/gm"
    },
    {
      "rus": "Будут ли на стенах картины?",
      "eng": "Will there be pictures on the walls?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Диета твоих родителей более здоровая, чем твоя",
      "eng": "Your parents` diet is healthier than yours",
      "regEng": ""
    },
    {
      "rus": "Это его деньги, не её",
      "eng": "This is his money, not hers",
      "regEng": "/(?:This (?:is his money|money is his), not hers)/gm"
    },
    {
      "rus": "Результаты этих людей хуже, чем его",
      "eng": "These people`s results are worse than his",
      "regEng": ""
    },
    {
      "rus": "Это комната твоих детей? Нет, она моя",
      "eng": "Is this your children`s room? No, it is mine",
      "regEng": "/(?:Is this your children`s room\\? No, (?:it is|it’s) mine)/gm"
    },
    {
      "rus": "Её волосы темнее или светлее, чем твои?",
      "eng": "Is her hair darker or lighter than yours?",
      "regEng": ""
    },
    {
      "rus": "Чей это телефон? Это телефон моего мужа",
      "eng": "Whose phone is this? This is my husband`s phone",
      "regEng": "/(?:Whose (?:tele)?phone is this\\? This is my husband`s (?:tele)?phone)/gm"
    },
    {
      "rus": "Собака наших соседей больше, чем наша",
      "eng": "Our neighbours` dog is bigger than ours",
      "regEng": "/(?:Our neighbou?rs` dog is bigger than ours)/gm"
    },
    {
      "rus": "Ваша одежда более дешёвая, чем их",
      "eng": "Your clothes are cheaper than theirs",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Вы более дружелюбны, чем они",
      "eng": "You are friendlier than they are",
      "regEng": "/(?:You(?: are|`re) friendlier than (?:they(?: are)?|them))/gm"
    },
    {
      "rus": "Они более серьезные, чем я",
      "eng": "They are more serious than I am",
      "regEng": "/(?:They(?: are|`re) more serious than (?:I(?: am)?|me))/gm"
    },
    {
      "rus": "Она ниже, чем ты",
      "eng": "She is shorter than you are",
      "regEng": "/(?:She(?: is|`s) shorter than you(?: are)?)/gm"
    },
    {
      "rus": "Я сильнее, чем он",
      "eng": "I am stronger than he is",
      "regEng": "/(?:(?:I am|I’m) stronger than (?:he(?: is)?|him))/gm"
    },
    {
      "rus": "Ты тоньше, чем она",
      "eng": "You are thinner than she is",
      "regEng": "/(?:You(?: are|`re) thinner than (?:she(?: is)?|her))/gm"
    },
    {
      "rus": "Они более обеспокоены, чем я",
      "eng": "They are more worried than I am",
      "regEng": "/(?:They(?: are|`re) more worried than (?:I(?: am)?|me))/gm"
    },
    {
      "rus": "Он красивее тебя",
      "eng": "He is more handsome than you are",
      "regEng": "/(?:(?:He is|He’s) more handsome than you(?: are)?)/gm"
    },
    {
      "rus": "Она моложе, чем он",
      "eng": "She is younger than he is",
      "regEng": "/(?:She(?: is|`s) younger than (?:he(?: is)?|him))/gm"
    }
  ],
  [
    {
      "rus": "Его руки слабее, чем мои",
      "eng": "His arms are weaker than mine",
      "regEng": ""
    },
    {
      "rus": "Чьи это билеты? Они наши",
      "eng": "Whose tickets are these? They are ours",
      "regEng": "/(?:Whose tickets are these\\? They(?: are|`re) ours)/gm"
    },
    {
      "rus": "Они более пассивны, чем мы",
      "eng": "They are more passive than we are",
      "regEng": "/(?:They(?: are|`re) more passive than (?:we(?: are)?|us))/gm"
    },
    {
      "rus": "Мой отчёт более подробный, чем ваш",
      "eng": "My report is more detailed than yours",
      "regEng": ""
    },
    {
      "rus": "Мы более привлекательны, чем они",
      "eng": "We are more attractive than they are",
      "regEng": "/(?:We(?: are|`re) more attractive than they are)/gm"
    },
    {
      "rus": "То ваши документы? Нет, мои здесь",
      "eng": "Are these your documents? No, mine are here",
      "regEng": "/(?:Are these (?:your documents|documents yours)\\? No, mine are here)/gm"
    },
    {
      "rus": "Твои волосы более короткие, чем её",
      "eng": "Your hair is shorter than hers",
      "regEng": ""
    },
    {
      "rus": "Вы более терпеливы, чем я",
      "eng": "You are more patient than I am",
      "regEng": "/(?:You(?: are|`re) more patient than (?:I(?: am)?|me))/gm"
    }
  ],
  [
    {
      "rus": "На столе стоит ящик",
      "eng": "There is a box on the table",
      "regEng": "/(?:There(?:`s| is) a box on the table)/gm"
    },
    {
      "rus": "Стоит ли ящик на столе?",
      "eng": "Is there a box on the table?",
      "regEng": ""
    },
    {
      "rus": "У окна стояли стулья",
      "eng": "There were chairs by the window",
      "regEng": ""
    },
    {
      "rus": "Стояли ли стулья у окна?",
      "eng": "Were there chairs by the window?",
      "regEng": ""
    },
    {
      "rus": "В ящике будут чашки",
      "eng": "There will be cups in the box",
      "regEng": "/(?:There(?:`ll| will) be cups in the box)/gm"
    },
    {
      "rus": "Будут ли в ящике чашки?",
      "eng": "Will there be cups in the box?",
      "regEng": ""
    },
    {
      "rus": "Под мостом стояла машина",
      "eng": "There was a car under the bridge",
      "regEng": ""
    },
    {
      "rus": "Стояла ли под мостом машина?",
      "eng": "Was there a car under the bridge?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "На кровати лежат игрушки",
      "eng": "There are toys on the bed",
      "regEng": ""
    },
    {
      "rus": "В двери будет замок",
      "eng": "There will be a lock in the door",
      "regEng": "/(?:(?:There will|There’ll) be a lock in the door)/gm"
    },
    {
      "rus": "Будет ли в двери замок?",
      "eng": "Will there be a lock in the door?",
      "regEng": ""
    },
    {
      "rus": "У окна стоит кресло",
      "eng": "There is an armchair by the window",
      "regEng": "/(?:(?:There is|There’s) an armchair by the window)/gm"
    },
    {
      "rus": "Стоит ли кресло у окна?",
      "eng": "Is there an armchair by the window?",
      "regEng": ""
    },
    {
      "rus": "В сумке лежал ключ",
      "eng": "There was a key in the bag",
      "regEng": ""
    },
    {
      "rus": "Лежал ли в сумке ключ?",
      "eng": "Was there a key in the bag?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "На полу стояли бутылки",
      "eng": "There were bottles on the floor",
      "regEng": ""
    },
    {
      "rus": "Стояли ли на полу бутылки?",
      "eng": "Were there bottles on the floor?",
      "regEng": ""
    },
    {
      "rus": "В комнате будет диван",
      "eng": "There will be a sofa in the room",
      "regEng": "/(?:(?:There will|There’ll) be a (?:sofa|couch) in the room)/gm"
    },
    {
      "rus": "Будет ли в комнате диван?",
      "eng": "Will there be a sofa in the room?",
      "regEng": "/(?:Will there be a (?:sofa|couch) in the room\\?)/gm"
    },
    {
      "rus": "На потолке висит лампа",
      "eng": "There is a lamp on the ceiling",
      "regEng": "/(?:(?:There is|There’s) a lamp on the ceiling)/gm"
    },
    {
      "rus": "Висит ли лампа на потолке?",
      "eng": "Is there a lamp on the ceiling?",
      "regEng": ""
    },
    {
      "rus": "Под кроватью стоят сумки",
      "eng": "There are bags under the bed",
      "regEng": ""
    },
    {
      "rus": "Стоят ли сумки под кроватью?",
      "eng": "Are there bags under the bed?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Откуда твоя подруга? Она из Англии",
      "eng": "Where is your friend from? She is from England",
      "regEng": "/(?:Where is your friend from\\? She(?: is|`s) from England)/gm"
    },
    {
      "rus": "Когда она купила это платье? Она купила его во вторник",
      "eng": "When did she buy this dress? She bought it on Tuesday",
      "regEng": ""
    },
    {
      "rus": "Я горжусь своей семьей и своими друзьями!",
      "eng": "I am proud of my family and my friends!",
      "regEng": "/(?:(?:I am|I’m) proud of my family and my friends!)/gm"
    },
    {
      "rus": "Чем занимается её муж? Её муж повар",
      "eng": "What does her husband do? Her husband is a cook",
      "regEng": ""
    },
    {
      "rus": "Девушка моего брата никогда не приходит вовремя. Вчера она опоздала опять",
      "eng": "My brother`s girlfriend is never on time. Yesterday she was late again",
      "regEng": ""
    },
    {
      "rus": "Что тебе нужно, чтобы она сделала? Мне нужно, чтобы она позвонила мне завтра",
      "eng": "What do you need her to do? I need her to call me tomorrow",
      "regEng": ""
    },
    {
      "rus": "Каждый месяц она ездит туда, чтобы увидеть их",
      "eng": "Every month she goes there to see them",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Я всегда счастлив поговорить с вами. Вы такой интересный человек",
      "eng": "I am always happy to talk to you. You are such an interesting person",
      "regEng": "/(?:(?:I am|I’m) always happy to (?:talk|speak) (?:to|with) you. You(?: are|`re) such an interesting person)/gm"
    },
    {
      "rus": "Ваши дети ходят в школу каждый день? Нет, по выходным они не ходят в школу",
      "eng": "Do your children go to school every day? No, at weekends they do not go to school",
      "regEng": "/(?:Do your children go to school every day\\? No, at weekends they (?:do not|don’t) go to school)/gm"
    },
    {
      "rus": "Ты пошёл спать поздно вчера? Нет, я пошёл спать рано",
      "eng": "Did you go to bed late yesterday? No, I went to bed early",
      "regEng": "/(?:Did you go to (?:bed|sleep) late yesterday\\? No, I went to (?:bed|sleep) early)/gm"
    },
    {
      "rus": "Чего она боится? Она боится всего",
      "eng": "What is she afraid of? She is afraid of everything",
      "regEng": "/(?:What is she afraid of\\? She(?: is|`s) afraid of everything)/gm"
    },
    {
      "rus": "Как вы обычно путешествуете? Я обычно путешествую самолётом",
      "eng": "How do you usually travel? I usually travel by plane",
      "regEng": ""
    },
    {
      "rus": "Я так голоден. Мне нужно пообедать",
      "eng": "I am so hungry. I need to have lunch",
      "regEng": "/(?:(?:I am|I’m) so hungry. I need to have lunch)/gm"
    },
    {
      "rus": "О чём вы часто думаете? Я часто думаю о своей семье",
      "eng": "What do you often think about? I often think about my family",
      "regEng": ""
    },
    {
      "rus": "Мы не хотим, чтобы вы сожалели. Всё в порядке",
      "eng": "We do not want you to be sorry. Everything is alright",
      "regEng": "/(?:We (?:do not|don’t) want you to be sorry. Everything is alright)/gm"
    }
  ],
  [
    {
      "rus": "Вчера ты пришел домой рано",
      "eng": "Yesterday you came home early",
      "regEng": "/(?:Yesterday you came home early)|(?:You came home early yesterday)/gm"
    },
    {
      "rus": "Мы более успешны, чем они",
      "eng": "We are more successful than they are",
      "regEng": "/(?:We(?: are|’re) more successful than (?:they(?: are)?|them))/gm"
    },
    {
      "rus": "То были часы его дедушки?",
      "eng": "Was that his grandfather`s watch?",
      "regEng": "/Was that his (?:grandfather’s|grandpa’s) watch\\?/gm"
    },
    {
      "rus": "Ему не нужно искать новую работу",
      "eng": "He does not need to look for a new job",
      "regEng": "/(?:He (?:does not|doesn’t) need to (?:look|search) for a new job)/gm"
    },
    {
      "rus": "Я спокойнее, чем она",
      "eng": "I am calmer than she is",
      "regEng": "/(?:(?:I am|I’m) calmer than (?:she(?: is)?|her))/gm"
    }
  ],
  [
    {
      "rus": "Они часто слушают этих людей",
      "eng": "They often listen to these people",
      "regEng": ""
    },
    {
      "rus": "В замке будет ключ",
      "eng": "There will be a key in the lock",
      "regEng": "/(?:There(?:’ll| will) be a key in the lock)/gm"
    },
    {
      "rus": "Я видел твою сестру час назад. Она спешила",
      "eng": "I saw your sister an hour ago. She was in a hurry",
      "regEng": ""
    },
    {
      "rus": "Мои руки сильнее, чем его",
      "eng": "My arms are stronger than his",
      "regEng": ""
    },
    {
      "rus": "Чей это телефон? Он мой",
      "eng": "Whose phone is this? It is mine",
      "regEng": "/(?:Whose (?:phone|telephone) is this\\? It(?: is|’s) mine)/gm"
    }
  ],
  [
    {
      "rus": "Это её юбка? Эта юбка её?",
      "eng": "Is this her skirt? Is this skirt hers?",
      "regEng": ""
    },
    {
      "rus": "Я всегда хожу на работу пешком. Мне нравится свежий воздух",
      "eng": "I always go to work on foot. I like fresh air",
      "regEng": ""
    },
    {
      "rus": "Стоит ли на столе чашка?",
      "eng": "Is there a cup on the table?",
      "regEng": ""
    },
    {
      "rus": "Её тело тоньше, чем твоё",
      "eng": "Her body is thinner than yours",
      "regEng": ""
    },
    {
      "rus": "Они пообедали час назад",
      "eng": "They had lunch an hour ago",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Я не был здесь минуту назад",
      "eng": "I was not here a minute ago",
      "regEng": "/I (?:was not|wasn’t) here a minute ago/gm"
    },
    {
      "rus": "Ищем ли мы часто интересные книги здесь?",
      "eng": "Do we often look for interesting books here?",
      "regEng": "/Do we often (?:look|search) for interesting books here\\?/gm"
    },
    {
      "rus": "Твои ресницы длиннее моих",
      "eng": "Your eyelashes are longer than mine",
      "regEng": ""
    },
    {
      "rus": "Кого вы хотите, чтобы я слушал?",
      "eng": "Who do you want me to listen to?",
      "regEng": ""
    },
    {
      "rus": "То её синяя машина. Та синяя машина её",
      "eng": "That is her blue car. That blue car is hers",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Чьи книги то были?",
      "eng": "Whose books were those?",
      "regEng": ""
    },
    {
      "rus": "Он хочет, чтобы она поужинала с ним",
      "eng": "He wants her to have dinner with him",
      "regEng": ""
    },
    {
      "rus": "Ваши истории интереснее наших",
      "eng": "Your stories are more interesting than ours",
      "regEng": ""
    },
    {
      "rus": "Она без ума от своего нового парня",
      "eng": "She is crazy about her new boyfriend",
      "regEng": "/(?:She(?: is|`s) crazy about her new boyfriend/gm"
    },
    {
      "rus": "На столе лежали книги",
      "eng": "There were books on the table",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Когда они принесут эти вещи сюда?",
      "eng": "When will they bring these things here?",
      "regEng": ""
    },
    {
      "rus": "Этот мальчик тренируется каждый день",
      "eng": "This boy exercises every day",
      "regEng": ""
    },
    {
      "rus": "Ты голоден? Нет, но я очень хочу пить",
      "eng": "Are you hungry? No, but I am very thirsty",
      "regEng": ""
    },
    {
      "rus": "Её руки грязнее, чем твои",
      "eng": "Her hands are dirtier than yours",
      "regEng": ""
    },
    {
      "rus": "Спешит ли он?",
      "eng": "Is he in a hurry?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "С кем он обычно ходит туда?",
      "eng": "Who does he usually go there with?",
      "regEng": ""
    },
    {
      "rus": "Результаты моего брата лучше, чем мои",
      "eng": "My brother’s results are better than mine",
      "regEng": ""
    },
    {
      "rus": "В декабре они редко ездят на работу на велосипеде",
      "eng": "In December they rarely go to work by bicycle",
      "regEng": "/In December they (?:rarely|seldom) go to work by bicycle/gm"
    },
    {
      "rus": "Этот зелёный зонтик наш, не их",
      "eng": "This green umbrella is ours, not theirs",
      "regEng": ""
    },
    {
      "rus": "С кем вы хотите, чтобы я поговорил?",
      "eng": "Who do you want me to talk to?",
      "regEng": "/Who do you want me to talk (?:to|with)\\?/gm"
    }
  ],
  [
    {
      "rus": "Эти люди обычно не приходят вовремя",
      "eng": "These people are not usually on time",
      "regEng": "/These people (?:are not|aren’t) usually on time/gm"
    },
    {
      "rus": "Кто готов помочь нам сегодня?",
      "eng": "Who is ready to help us today?",
      "regEng": ""
    },
    {
      "rus": "То твои книги? Нет, мои здесь",
      "eng": "Are those your books? No, mine are here",
      "regEng": ""
    },
    {
      "rus": "Почему он часто ужинает там в понедельник?",
      "eng": "Why does he often have dinner there on Monday?",
      "regEng": ""
    },
    {
      "rus": "Чего боялись те дети?",
      "eng": "What were those children afraid of?",
      "regEng": "/What were those children (?:afraid|scared) of\\?/gm"
    }
  ],
  [
    {
      "rus": "То не были документы её отца",
      "eng": "Those were not her father`s documents",
      "regEng": "/Those (?:were not|weren’t) her (?:father`s|dad`s) documents/gm"
    },
    {
      "rus": "На прошлой неделе они поужинали вместе",
      "eng": "Last week they had dinner together",
      "regEng": ""
    },
    {
      "rus": "Ваша ситуация хуже, чем их",
      "eng": "Your situation is worse than theirs",
      "regEng": ""
    },
    {
      "rus": "Ты знаешь тех людей?",
      "eng": "Do you know those people?",
      "regEng": ""
    },
    {
      "rus": "Чей то был магазин? То был магазин моей семьи",
      "eng": "Whose shop was that? That was my family`s shop",
      "regEng": "/Whose (?:shop|store) was that\\? That was my family`s (?:shop|store)/gm"
    }
  ],
  [
    {
      "rus": "Завтра ты пойдешь в кровать поздно",
      "eng": "Tomorrow you will go to bed late",
      "regEng": ""
    },
    {
      "rus": "То были ваши деньги. Те деньги были ваши",
      "eng": "That was your money. That money was yours",
      "regEng": ""
    },
    {
      "rus": "Его волосы короче, чем её",
      "eng": "His hair is shorter than hers",
      "regEng": ""
    },
    {
      "rus": "Она не всегда слушает эти песни в среду",
      "eng": "She does not always listen to these songs on Wednesday",
      "regEng": "/She (?:does not|doesn’t) always listen to these songs on Wednesday/gm"
    },
    {
      "rus": "Рад ли этот мужчина всегда видеть её?",
      "eng": "Is this man always glad to see her?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Очень ли тебе холодно?",
      "eng": "Are you very cold?",
      "regEng": ""
    },
    {
      "rus": "О чём мы подумаем через неделю?",
      "eng": "What will we think about in a week?",
      "regEng": ""
    },
    {
      "rus": "Эти женщины кушают такие вкусные пирожные всё время",
      "eng": "These women eat such tasty cakes all the time",
      "regEng": ""
    },
    {
      "rus": "То были их серебряные серёжки? Те серебряные серёжки были их?",
      "eng": "Were those their silver earrings? Were those silver earrings theirs?",
      "regEng": ""
    },
    {
      "rus": "Поехали ли они домой на поезде месяц назад?",
      "eng": "Did they go home by train a month ago?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "О чём был тот фильм?",
      "eng": "What was that film about?",
      "regEng": "/What was that (?:film|movie) about?/gm"
    },
    {
      "rus": "Он будет очень успешным в следующем году",
      "eng": "He will be very successful next year",
      "regEng": "/(?:He will|He’ll) be very successful next year/gm"
    },
    {
      "rus": "Чей то родственник? То родственник его жены",
      "eng": "Whose relative is that? That is his wife’s relative",
      "regEng": ""
    },
    {
      "rus": "Он всегда ждёт этих вечеринок",
      "eng": "He always waits for these parties",
      "regEng": ""
    },
    {
      "rus": "С кем она приедет сюда через год?",
      "eng": "Who will she come here with in a year?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Что ему нужно искать?",
      "eng": "What does he need to look for?",
      "regEng": "/What does he need to (?:look|search) for\\?/gm"
    },
    {
      "rus": "Это твои брюки? Эти брюки твои?",
      "eng": "Are these your trousers? Are these trousers yours?",
      "regEng": "/Are these your (?:trousers|pants)\\? Are these (?:trousers|pants) yours\\?/gm"
    },
    {
      "rus": "Их бутерброды вкуснее, чем мои",
      "eng": "Their sandwiches are tastier than mine",
      "regEng": "/Their sandwiches are (?:tastier|more delicious) than mine/gm"
    },
    {
      "rus": "Вы не опоздали в понедельник",
      "eng": "You were not late on Monday",
      "regEng": "/(?:You (?:were not|weren’t) late on Monday)|(?:On Monday You (?:were not|weren’t) late)/gm"
    },
    {
      "rus": "Я хочу, чтобы мы пошли в это место вместе в четверг",
      "eng": "I want us to go to this place together on Thursday",
      "regEng": "/(?:I want us to go to this place together on Thursday)|(?:On Thursday I want is to go to this place together)/gm"
    }
  ],
  [
    {
      "rus": "Эта одежда их, не наша",
      "eng": "These clothes are theirs, not ours",
      "regEng": "/These clothes are theirs, (?:not ours|they are not ours|they’re not ours|these are not ours|these aren’t ours)/gm"
    },
    {
      "rus": "Этот мужчина не всегда будет гордиться своей дочерью",
      "eng": "This man will not always be proud of his daughter",
      "regEng": "/This man (?:will not|won’t) always be proud of his daughter/gm"
    },
    {
      "rus": "Завтра я попытаюсь закончить это упражнение",
      "eng": "Tomorrow I will try to finish this exercise",
      "regEng": "/Tomorrow (?:I will|I’ll) try to finish this exercise/gm"
    },
    {
      "rus": "Ей нравится шоколад?",
      "eng": "Does she like chocolate?",
      "regEng": ""
    },
    {
      "rus": "Чьи это платья? Они твои",
      "eng": "Whose dresses are these? They are yours",
      "regEng": "/Whose dresses are these\\? (?:They are|They’re) yours/gm"
    }
  ],
  [
    {
      "rus": "Вы разговариваете со своими коллегами каждый понедельник",
      "eng": "You talk to your colleagues every Monday",
      "regEng": "/You talk (?:to|with) your colleagues every Monday/gm"
    },
    {
      "rus": "Мы не часто говорим об этом бизнесе",
      "eng": "We do not often talk about this business",
      "regEng": "/We (?:do not|don’t) often (?:talk|speak) about this business/gm"
    },
    {
      "rus": "У неё красивая дочка",
      "eng": "She has a beautiful daughter",
      "regEng": ""
    },
    {
      "rus": "Где живёт твоя подруга?",
      "eng": "Where does your friend live?",
      "regEng": ""
    },
    {
      "rus": "Они играют в теннис каждый день",
      "eng": "They play tennis every day",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Чьи это брюки? Они Джона",
      "eng": "Whose trousers are these? They are John`s",
      "regEng": "/Whose (?:trousers|pants) are these\\? (?:They are|They’re|These are) John`s/gm"
    },
    {
      "rus": "Она более активная, чем я",
      "eng": "She is more active than me",
      "regEng": "/(?:She(?: is|`s)) more active than me/gm"
    },
    {
      "rus": "Чья это ручка? Она моей сестры",
      "eng": "Whose pen is this? It is my sister`s",
      "regEng": "/Whose pen is this\\? (?:It is|It’s) my sister`s/gm"
    },
    {
      "rus": "Твои волосы темнее, чем у твоего брата",
      "eng": "Your hair is darker than your brother`s",
      "regEng": ""
    },
    {
      "rus": "Они более грустные, чем мы",
      "eng": "They are sadder than us",
      "regEng": "/(?:They are|They’re) sadder than (?:us|we are|we)/gm"
    },
    {
      "rus": "Дети этих женщин спокойнее наших",
      "eng": "These women`s children are calmer than ours",
      "regEng": ""
    },
    {
      "rus": "Это твоя машина? Нет, она моих родителей",
      "eng": "Is this your car? No, it is my parents`",
      "regEng": "/Is this (?:your car|car yours)\\? No, (?:it is|it’s) my parents`/gm"
    },
    {
      "rus": "Чей это компьютер? Он Мэри",
      "eng": "Whose computer is this? It is Mary`s",
      "regEng": "/Whose computer is this\\? (?:It is|It’s) Mary`s/gm"
    }
  ],
  [
    {
      "rus": "Я счастливее, чем они",
      "eng": "I am happier than them",
      "regEng": "/(?:I am|I’m) happier than (?:them|they are|they)/gm"
    },
    {
      "rus": "Чья это одежда? Она наших сыновей",
      "eng": "Whose clothes are these? They are our sons`",
      "regEng": "/Whose clothes are these\\? (?:They are|They’re|These) our sons’/gm"
    },
    {
      "rus": "Ты более талантливый, чем она",
      "eng": "You are more talented than her",
      "regEng": "/(?:You are|You’re) more talented than (?:she(?: is)?|her)/gm"
    },
    {
      "rus": "Их дом больше, чем у их соседей",
      "eng": "Their house is bigger than their neighbours`",
      "regEng": "/Their house is (?:bigger|larger) than their neighbou?rs`/gm"
    },
    {
      "rus": "Чьи то туфли? Они моей матери",
      "eng": "Whose shoes are those? They are my mother`s",
      "regEng": "/Whose shoes are those\\? (?:They(?:`re)?|Those) are my (?:mother|mom|mum)`s/gm"
    },
    {
      "rus": "Эти часы не мои, они моего отца",
      "eng": "This watch is not mine, it is my father`s",
      "regEng": "/This(?: watch)? (?:is not|isn`t) (?:mine|my watch), it(?: is|`s) my (?:father|dad|daddy)`s/gm"
    },
    {
      "rus": "Журналы твоих друзей интереснее, чем твои",
      "eng": "Your friends` magazines are more interesting than yours",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "На полке лежат журналы",
      "eng": "There are magazines on the shelf",
      "regEng": ""
    },
    {
      "rus": "Лежат ли на полке журналы?",
      "eng": "Are there magazines on the shelf?",
      "regEng": ""
    },
    {
      "rus": "На диване была подушка",
      "eng": "There was a cushion on the sofa",
      "regEng": "/There was a cushion on the (?:sofa|couch)/gm"
    },
    {
      "rus": "Была ли на диване подушка?",
      "eng": "Was there a cushion on the sofa?",
      "regEng": "/Was there a cushion on the (?:sofa|couch)\\?/gm"
    },
    {
      "rus": "У стены будут ящики",
      "eng": "There will be boxes by the wall",
      "regEng": "/There(?: will|`ll) be boxes by the wall/gm"
    },
    {
      "rus": "Будут ли у стены ящики?",
      "eng": "Will there be boxes by the wall?",
      "regEng": ""
    },
    {
      "rus": "На потолке есть пятно",
      "eng": "There is a stain on the ceiling",
      "regEng": "/There(?: is|`s) a stain on the ceiling/gm"
    },
    {
      "rus": "Есть ли пятно на потолке?",
      "eng": "Is there a stain on the ceiling?",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "В доме есть какие-то люди",
      "eng": "There are some people in the house",
      "regEng": ""
    },
    {
      "rus": "Есть ли в доме какие-нибудь люди?",
      "eng": "Are there any people in the house?",
      "regEng": ""
    },
    {
      "rus": "В доме нет никаких людей",
      "eng": "There aren`t any people in the house",
      "regEng": "/There (?:are not|aren`t) any people in the house/gm"
    },
    {
      "rus": "В доме нет никаких людей",
      "eng": "There are no people in the house",
      "regEng": ""
    },
    {
      "rus": "В бутылке было немного воды",
      "eng": "There was some water in the bottle",
      "regEng": ""
    },
    {
      "rus": "Было ли в бутылке сколько-нибудь воды?",
      "eng": "Was there any water in the bottle?",
      "regEng": ""
    },
    {
      "rus": "В бутылке не было никакой воды",
      "eng": "There wasn`t any water in the bottle",
      "regEng": "/There (?:was not|wasn`t) any water in the bottle/gm"
    },
    {
      "rus": "В бутылке не было никакой воды",
      "eng": "There was no water in the bottle",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "На столе будут кое-какие тарелки",
      "eng": "There will be some plates on the table",
      "regEng": "/There(?: will|`ll) be some plates on the table/gm"
    },
    {
      "rus": "Будут ли на столе какие-нибудь тарелки?",
      "eng": "Will there be any plates on the table?",
      "regEng": ""
    },
    {
      "rus": "На столе не будет никаких тарелок",
      "eng": "There won`t be any plates on the table",
      "regEng": "/There (?:will not|won`t) be any plates on the table/gm"
    },
    {
      "rus": "На столе не будет никаких тарелок",
      "eng": "There will be no plates on the table",
      "regEng": "/There(?: will|`ll) be no plates on the table/gm"
    },
    {
      "rus": "Под деревом было сколько-то яблок",
      "eng": "There were some apples under the tree",
      "regEng": ""
    },
    {
      "rus": "Было ли сколько-нибудь яблок под деревом?",
      "eng": "Were there any apples under the tree?",
      "regEng": ""
    },
    {
      "rus": "Под деревом не было никаких яблок",
      "eng": "There weren`t any apples under the tree",
      "regEng": "/There (?:were not|weren`t) any apples under the tree/gm"
    },
    {
      "rus": "Под деревом не было никаких яблок",
      "eng": "There were no apples under the tree",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Где дети? Я видел их в саду минуту назад",
      "eng": "Where are the children? I saw them in the garden a minute ago",
      "regEng": ""
    },
    {
      "rus": "У окна стоит кресло. Кресло синее",
      "eng": "There is an armchair by the window. The armchair is blue",
      "regEng": "/There(?: is|`s) an armchair by the window. The armchair is blue/gm"
    },
    {
      "rus": "Ты закрыл дверь? Я не помню",
      "eng": "Did you close the door? I do not remember",
      "regEng": "/Did you close the door\\? I (?:do not|don’t) remember/gm"
    },
    {
      "rus": "Мы хотим, чтобы они наслаждались солнцем и морем",
      "eng": "We want them to enjoy the sun and the sea",
      "regEng": ""
    },
    {
      "rus": "Где сумка? Она в машине",
      "eng": "Where is the bag? It is in the car",
      "regEng": "/Where(?: is|`s) the bag\\? (?:It is|It’s) in the car/gm"
    },
    {
      "rus": "На прошлой неделе она купила новое платье. Платье было очень дорогое",
      "eng": "Last week she bought a new dress. The dress was very expensive",
      "regEng": ""
    },
    {
      "rus": "Мне нужно, чтобы вы закончили задания через час",
      "eng": "I need you to finish the exercises in an hour",
      "regEng": ""
    },
    {
      "rus": "Ветер сильный сегодня, вчера он был слабее",
      "eng": "The wind is strong today, yesterday it was weaker",
      "regEng": ""
    }
  ],
  [
    {
      "rus": "Мой ответ лучше, чем у Кейт",
      "eng": "My answer is better than Kate`s",
      "regEng": ""
    },
    {
      "rus": "Чья это комната? Она моей тёти",
      "eng": "Whose room is this? It is my aunt`s",
      "regEng": "/Whose room is this\\? (?:It is|It’s) my aunt’s/gm"
    },
    {
      "rus": "Ты более стройная, чем она",
      "eng": "You are slimmer than her",
      "regEng": "/(?:You are|You’re) slimmer than (?:she(?: is)?|her)/gm"
    },
    {
      "rus": "Это не моя идея, она моего отца",
      "eng": "This is not my idea, it is my father`s",
      "regEng": "/This (?:is not|isn`t) my idea, (?:it is|it`s) my (?:father`s|dad`s)/gm"
    },
    {
      "rus": "Это ваши собаки? Нет, они наших соседей",
      "eng": "Are these your dogs? No, they are our neighbours`",
      "regEng": "/Are these your dogs\\? No, (?:they are|they’re|these are) our neighbou?rs`/gm"
    },
    {
      "rus": "Мы более уставшие, чем он",
      "eng": "We are more tired than him",
      "regEng": "/We(?: are|`re) more tired than (?:him|he(?: is)?)/gm"
    },
    {
      "rus": "Твоя одежда более стильная, чем её",
      "eng": "Your clothes are more stylish than hers",
      "regEng": ""
    },
    {
      "rus": "Это деньги моего дяди, не мои",
      "eng": "This is my uncle`s money, not mine",
      "regEng": "/This (?:is my uncle`s money|money is my uncle`s), not mine/gm"
    }
  ],
  [
    {
      "rus": "То твой ключ? Нет, он Пола или Джека",
      "eng": "Is that your key? No, it is Paul`s or Jack`s",
      "regEng": "/Is that your key\\? No, (?:it is|it`s) Paul`s or Jack`s/gm"
    },
    {
      "rus": "Я более успешный, чем они",
      "eng": "I am more successful than them",
      "regEng": "/(?:I am|I’m) more successful than (?:them|they are|they)/gm"
    },
    {
      "rus": "Глаза их дочерей светлее, чем у них",
      "eng": "Their daughters` eyes are lighter than theirs",
      "regEng": ""
    },
    {
      "rus": "Его жена терпеливее, чем он",
      "eng": "His wife is more patient than him",
      "regEng": "/His wife(?: is|`s) more patient than (?:him|he(?: is)?)/gm"
    },
    {
      "rus": "Волосы Кейт длиннее, чем у тебя",
      "eng": "Kate`s hair is longer than yours",
      "regEng": ""
    },
    {
      "rus": "Чьи то куртки? Они наших детей",
      "eng": "Whose jackets are those? They are our children`s",
      "regEng": "/Whose jackets are those\\? (?:They are|They’re|These) our children`s/gm"
    },
    {
      "rus": "Мой друг младше (моложе) меня",
      "eng": "My friend is younger than me",
      "regEng": "/My friend(?: is|`s) younger than (?:I(?: am)?|me)/gm"
    }
  ]
];
